$(document).ready(function () {
  var currentProductId = $('custom-build-product').attr('data-pid');
  var currentProductTitle = $('custom-build-product').attr('data-title');
  var currentProductType = $('custom-build-product').attr('data-protype');
  var uid = 'id-' + Date.now() + '-' + Math.floor(Math.random() * 1000);

  // Finish tiers (docs/PRICING_TIERS_SPEC.md). Tier is a property of the
  // COLOUR (option data-tier: 0 raw, 1 solid, 2 metallic/polished, 3 custom;
  // catalog powders always 3); the price for a tier is a property of the
  // VARIANT (data-tier-raw / -2 / -3 in dollars, tier 1 = data-baseprice).
  // The combo is charged at its HIGHEST tier: black+red = red+black = 2,
  // black+raw = 1, raw+raw = raw. Both return null unless the product is in
  // tier mode so the percent path stays byte-identical; cpbTierPrice also
  // returns null when the variant is missing any tier price (fall back to
  // percent rather than guess). A "free powder coating" promo is the
  // element's data-coating-promo N (shop metafield, product override):
  // the combo is charged at tier max(T - N, 0) — N=1 shifts every tier down
  // one (solids at the raw price), N=3 puts every combo at the raw price.
  // Mirrored in test/pricing-tiers.test.js.
  function cpbTierOf(mode, priOpt, secOpt) {
    if (mode !== 'tier') return null;
    var t = function (o) { return o ? parseInt(o.getAttribute('data-tier'), 10) : NaN; };
    var a = t(priOpt), b = t(secOpt);
    if (isNaN(a) && isNaN(b)) return null;
    return Math.max(isNaN(a) ? 0 : a, isNaN(b) ? 0 : b);
  }
  function cpbTierPrice(mode, variantEl, priOpt, secOpt, promo) {
    var tier = cpbTierOf(mode, priOpt, secOpt);
    if (tier === null || !variantEl) return null;
    tier = Math.max(tier - (parseInt(promo, 10) || 0), 0);
    var dollars = function (k) {
      var v = (variantEl.getAttribute(k) || '').replace(/[^0-9.]/g, '');
      return v === '' ? NaN : parseFloat(v);
    };
    var raw = dollars('data-tier-raw'), t2 = dollars('data-tier-2'), t3 = dollars('data-tier-3');
    if (isNaN(raw) || isNaN(t2) || isNaN(t3)) return null;
    var base = Number(variantEl.getAttribute('data-baseprice') || 0); // cents
    var cents = { 0: Math.round(raw * 100), 1: base, 2: Math.round(t2 * 100), 3: Math.round(t3 * 100) };
    return cents[tier] === undefined ? cents[3] : cents[tier];
  }
  window.cpbTierOf = cpbTierOf;

  // Storefront promo (Shopify automatic discount, snippets/tso-promo.liquid).
  // DISPLAY ONLY — the discount charges. `el` is the builder root or an
  // accessory tile carrying data-promo-pct / data-promo-amount (cents, per item)
  // / data-promo-badge. Same maths as the discount on one cart line: percent =
  // round the cents off the line total; fixed = amount × qty, never below 0.
  function cpbPromoPrice(cents, el, qty) {
    el = el && el.jquery ? el[0] : el;
    if (!el) return cents;
    var pct = Number(el.getAttribute("data-promo-pct")) || 0;
    var amt = Number(el.getAttribute("data-promo-amount")) || 0;
    var off = pct > 0 ? Math.round((cents * pct) / 100) : Math.min(cents, amt * (qty || 1));
    return cents - off;
  }
  // "$359.92 <s>$449.90</s>" when a promo applies, plain money otherwise.
  function cpbPriceHtml(cents, el, withTag) {
    var sale = cpbPromoPrice(cents, el);
    if (sale >= cents) return Shopify.formatMoney(cents);
    var badge = $(el).attr("data-promo-badge") || "";
    return Shopify.formatMoney(sale) +
      ' <s class="cpb-sale-was">' + Shopify.formatMoney(cents) + '</s>' +
      (withTag && badge ? ' <span class="cpb-sale-tag">' + $("<i>").text(badge).html() + '</span>' : '');
  }
  window.cpbPromoPrice = cpbPromoPrice;

  // dattum_uuid is a free-text field (on both the color metaobject and the
  // variant), so it can hold whatever the ERP cron — or a hand edit — put there.
  // The ERP only accepts canonical dashed form; anything else trips its noisy
  // "invalid" flag. Normalize the forms that are unambiguously a uuid (braced,
  // uppercase, undashed) and return '' for anything else, so the caller omits
  // the property rather than sending a value that gets flagged.
  // Mirrored by test/dattum-uuid.test.js.
  function canonicalUuid(v) {
    var hex = String(v == null ? '' : v).trim().replace(/^\{/, '').replace(/\}$/, '').replace(/-/g, '').toLowerCase();
    if (!/^[0-9a-f]{32}$/.test(hex)) return '';
    return hex.replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '$1-$2-$3-$4-$5');
  }

  /* Stamp WHICH TRUCK PAINT a colour was matched to onto a cart line.
     "Primary Color" carries the powder (or, for an unmapped paint, the generic
     "Color Match" service) and "_Primary Color GID" carries that entry's id —
     neither says anything about the truck. Every unmapped paint on every truck
     shares one label and one sentinel GID, so a two-tone build arrives as two
     identical lines with the paint unrecoverable.

     These keys are ADDITIVE and hidden: nothing the ERP or the Cart Transform
     reads today changes, so they are inert until something learns to read them.
     Present only when a match TILE made the pick (powder-search.js stamps the
     option); a plain swatch or search-panel pick omits them.
     Mirrored by test/color-match-tiles.test.js. */
  function addMatchPaintProps(props, $priOpt, $secOpt) {
    [['Primary', $priOpt], ['Secondary', $secOpt]].forEach(function (pair) {
      var $o = pair[1];
      if (!$o || !$o.length) return;
      var paint = $o.attr('data-tso-match-paint');
      if (!paint) return;
      props['_' + pair[0] + ' Color Match'] = paint;
      var gid = $o.attr('data-tso-match-paint-gid');
      if (gid) props['_' + pair[0] + ' Color Match GID'] = gid;
    });
  }

  /* Programmatic select updates must dispatch a NATIVE change event: the vanilla
     swatch/dropdown drivers (main-pri-sec-color-selection, custom-select-product-popup,
     cpb-dropdown.js) listen via addEventListener, which jQuery's .trigger('change')
     never reaches (audit P1-A). Native dispatch also bubbles to jQuery's delegated
     handlers, so they still run exactly once. */
  function cpbSetSelect($el, val) {
    $el.val(val).each(function () {
      this.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // ---- ONE step model -------------------------------------------------
  // Rail chips and content panels are emitted by two parallel Liquid loops
  // in the SAME order (custom-product-build.liquid:122-186 and :204-315),
  // so rail[i] pairs with panel[i] and canonical index = DOM position.
  // The `product-step` attribute is a static Liquid literal that goes stale
  // the moment a step hides. Never read it FOR NAVIGATION/JS — this file
  // does not. As of 2026-07-15 it is fully vestigial repo-wide: the one CSS
  // rule that still keyed off it (custom-product-build-style.liquid's
  // `.cpb-fitment-slot` visibility selector) was fixed to key off DOM/hidden
  // position instead, and nothing else reads the attribute — only the
  // Liquid template still WRITES it. Still check that stylesheet before
  // adding any new rule; a future one could reintroduce a reader unnoticed.
  // Mirrored by test/builder-step-model.test.js.
  function cpbVisibleIndices(hiddenFlags) {
    var out = [];
    for (var i = 0; i < hiddenFlags.length; i++) if (!hiddenFlags[i]) out.push(i);
    return out;
  }

  function cpbClampActive(active, visibleCount) {
    if (!visibleCount) return 1;
    return Math.min(Math.max(1, active), visibleCount);
  }

  // Step visual → product card image (spec 2026-07-23, Ben rework).
  // The per-step .cpb-step-visual block is a hidden DATA SOURCE; while the
  // CURRENT step carries one, its img + caption REPLACE the product card image.
  // Steps without a visual restore the card's natural (variant/hero) image.
  // Natural src/srcset are stamped lazily here or by the variant-image update,
  // and overrides ONLY ever come from this function, so the lazy capture always
  // reads a clean natural state. Money-path: any failure → natural card image.
  function cpbApplyCardVisual() {
    var img = document.querySelector('.custom-options-product-card .custom-product-left img');
    if (!img) return;
    try {
      if (!img.hasAttribute('data-cpb-natural-src')) {
        img.setAttribute('data-cpb-natural-src', img.getAttribute('src') || '');
        img.setAttribute('data-cpb-natural-srcset', img.getAttribute('srcset') || '');
      }
      var caption = img.parentNode.querySelector('.cpb-card-caption');
      if (!caption) {
        caption = document.createElement('p');
        caption.className = 'cpb-card-caption';
        caption.hidden = true;
        img.parentNode.appendChild(caption);
      }
      var panel = document.querySelector('.custom-product-content-step.current');
      var vimg = panel ? panel.querySelector('.cpb-step-visual img') : null;
      var vsrc = vimg ? (vimg.getAttribute('src') || '') : '';
      if (vsrc) {
        if (img.getAttribute('src') !== vsrc) img.setAttribute('src', vsrc);
        img.removeAttribute('srcset'); // else the responsive set overrides src
        var capEl = panel.querySelector('.cpb-step-visual-caption');
        var capText = capEl ? capEl.textContent.trim() : '';
        caption.textContent = capText;
        caption.hidden = !capText;
      } else {
        var nat = img.getAttribute('data-cpb-natural-src') || '';
        if (img.getAttribute('src') !== nat) img.setAttribute('src', nat);
        var natSet = img.getAttribute('data-cpb-natural-srcset') || '';
        if (natSet) img.setAttribute('srcset', natSet); else img.removeAttribute('srcset');
        caption.hidden = true;
        caption.textContent = '';
      }
    } catch (err) {
      try {
        var nat2 = img.getAttribute('data-cpb-natural-src');
        if (nat2) img.setAttribute('src', nat2);
        var cap2 = img.parentNode ? img.parentNode.querySelector('.cpb-card-caption') : null;
        if (cap2) cap2.hidden = true;
      } catch (e2) {}
      if (window.tsoReportError) window.tsoReportError('cpb-step-visuals: card visual failed', { error: String(err) });
    }
  }

  // mirrored in test/builder-step-visuals.test.js — keep identical
  function cpbNormValue(v) {
    return String(v == null ? '' : v).replace(/"/g, '').trim().toLowerCase();
  }

  // mirrored in test/builder-step-visuals.test.js — keep identical
  function cpbEffectiveAutoAdvance(cfg, legacyAdvance) {
    if (!cfg || !cfg.mode) return !!legacyAdvance;
    if (cfg.auto === true || cfg.auto === false) return cfg.auto;
    return cfg.mode === 'asset';
  }

  // mirrored in test/builder-step-visuals.test.js — keep identical
  var CPB_LOOKUP_ATTRS = ['engine', 'bed_length', 'cab_size', 'trim', 'rear_wheel', 'drivetrain'];
  function cpbParseLookup(str) {
    if (!str) return null;
    var i = String(str).indexOf('.');
    if (i < 1) return null;
    var attr = str.slice(0, i).trim(), field = str.slice(i + 1).trim();
    if (CPB_LOOKUP_ATTRS.indexOf(attr) === -1 || !field) return null;
    return { attr: attr, field: field };
  }

  // cookie: parsed vehicle_selection payload ({engine_gid: "gid://shopify/Metaobject/123", ...}) or null
  // attrs: {engine: {"123": {factory_inlet_size: "4 in"}}, ...} (bare system.id keys)
  // optionValues: array of this option's values; fittingValues: array of values
  // carried by >=1 fitting variant, or null when no vehicle is saved.
  // mirrored in test/builder-step-visuals.test.js — keep identical
  function cpbResolveAnswer(ans, cookie, attrs, optionValues, fittingValues) {
    var value = null;
    var lk = cpbParseLookup(ans && ans.lookup);
    if (lk) {
      if (!cookie) return { ok: false };
      var gid = cookie[lk.attr + '_gid'];
      if (!gid) return { ok: false };
      var id = String(gid).split('/').pop();
      var entry = (attrs[lk.attr] || {})[id];
      var raw = entry && entry[lk.field];
      if (raw == null || String(raw).trim() === '') return { ok: false };
      value = raw;
    } else if (ans && ans.value != null && String(ans.value).trim() !== '') {
      value = ans.value;
    } else {
      return { ok: false }; // blank answer = "open the step", never resolves
    }
    var norm = cpbNormValue(value);
    var inOptions = optionValues.some(function (v) { return cpbNormValue(v) === norm; });
    if (!inOptions) return { ok: false };
    if (fittingValues !== null) {
      var fits = fittingValues.some(function (v) { return cpbNormValue(v) === norm; });
      if (!fits) return { ok: false };
    }
    return { ok: true, value: value };
  }

  // mirrored in test/builder-step-visuals.test.js — keep identical
  function cpbReconcile(prevApplied, res) {
    if (prevApplied == null) return res.ok ? 'noop' : 'release';
    if (!res.ok) return 'release';
    return cpbNormValue(res.value) === cpbNormValue(prevApplied) ? 'noop' : 'reapply';
  }

  // Money-path fail-safe: any error inside the prereq/visual layer must leave
  // the builder in its pre-feature state — all option steps visible, no
  // applying flag stuck. Prereq pairs are hidden (inert = safest: a dead
  // prereq shows nothing, and its target is un-hidden below). Un-hides ONLY
  // nodes the prereq layer itself hid (data-cpb-hidden-by-prereq) — never
  // accessory-set steps hidden by cpbEvaluateGates or option steps hidden by
  // any other feature. Never throws.
  function cpbFailSafe(err) {
    try {
      window.__cpbPrereqApplying = false;
      document.querySelectorAll('.cpb-prereq-rail, .prereq-step').forEach(function (el) { el.hidden = true; });
      document.querySelectorAll('.custom-product-content-step.option-steps, .custom-product-step:not(.cpb-prereq-rail)').forEach(function (el) {
        if (el.hasAttribute('data-cpb-hidden-by-prereq')) { el.hidden = false; el.removeAttribute('data-cpb-hidden-by-prereq'); }
      });
      var cbp = document.querySelector('custom-build-product');
      if (cbp && typeof cbp.cpbSyncSteps === 'function') cbp.cpbSyncSteps();
      if (window.tsoReportError) window.tsoReportError('cpb-step-visuals: prereq layer failed', { error: String(err) });
    } catch (e2) { /* never throw from the fail-safe */ }
  }


  // ---- Vehicle fitment option-filter helpers ----
  window.__builderShowNonFitting = window.__builderShowNonFitting || false;
  var __fitCache = {};
  function getVehicleSelection() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)vehicle_selection=([^;]+)/);
      if (!m) return null;
      var v = JSON.parse(decodeURIComponent(m[1]));
      return (v && v.year && v.make && v.model) ? v : null;
    } catch (e) { return null; }
  }
  function gidId(s){ return s == null ? s : String(s).split('/').pop(); }

  // ---- Accessory fitment blob (Task 3 -> Task 4, D6) ----
  // ONE page-wide script (unlike base's per-variant `vehicle-fitment-json-<id>`
  // scripts): { "<varid>": {generations, engine, ...} }, BARE — no
  // {variantFitment: ...} wrapper. Parsed once and memoized: the blob is
  // static after render (unlike __fitCache, which is keyed by the current
  // selection and invalidated on vehicle:selection:updated), so this memo
  // needs no invalidation.
  var __cpbAccessoryFitmentCache = null;
  function cpbAccessoryFitment() {
    if (__cpbAccessoryFitmentCache) return __cpbAccessoryFitmentCache;
    var el = document.getElementById('cpb-accessory-fitment');
    if (!el) { __cpbAccessoryFitmentCache = {}; return __cpbAccessoryFitmentCache; }
    try {
      __cpbAccessoryFitmentCache = JSON.parse(el.textContent || '{}') || {};
    } catch (e) {
      __cpbAccessoryFitmentCache = {};
    }
    return __cpbAccessoryFitmentCache;
  }

  function variantFitsVehicle(varid, sel) {
    if (!sel) return true;
    var key = varid + '|' + [sel.filter_value, sel.engine_gid, sel.bed_length_gid, sel.trim_gid, sel.rear_wheel_gid, sel.cab_size_gid, sel.drivetrain_gid].map(gidId).join('~');
    if (key in __fitCache) return __fitCache[key];
    var fits = (function () {
      var el = document.getElementById('vehicle-fitment-json-' + varid);
      var vf;
      if (el) {
        var data; try { data = JSON.parse(el.textContent || '{}'); } catch (e) { return true; }
        vf = (data && data.variantFitment) || {};
      } else {
        // Accessory variants (Task 3) have no per-variant script; their fitment
        // lives BARE in the page-wide cpb-accessory-fitment blob — used
        // directly, never unwrapped via .variantFitment.
        vf = cpbAccessoryFitment()[varid];
        if (!vf) return true;
      }
      // No universal short-circuit: universal products emit EMPTY generations (so the generation
      // check below is skipped — they fit any generation), but their ATTRIBUTE filters (engine,
      // bed, trim, etc.) must STILL apply. e.g. the overlay tip is universal yet engine-filtered.
      var gens = (vf.generations || []).map(gidId);
      if (gens.length && sel.filter_value && gens.indexOf(gidId(sel.filter_value)) === -1) return false;
      var attrs = [['engine','engine_gid'],['bed_length','bed_length_gid'],['trim','trim_gid'],['rear_wheel','rear_wheel_gid'],['cab_size','cab_size_gid'],['drivetrain','drivetrain_gid']];
      for (var i = 0; i < attrs.length; i++) {
        var sgid = gidId(sel[attrs[i][1]]);
        var allowed = (vf[attrs[i][0]] || []).map(gidId);
        if (sgid && allowed.length && allowed.indexOf(sgid) === -1) return false;
      }
      return true;
    })();
    __fitCache[key] = fits;
    return fits;
  }

  // ---- Accessory VARIANT-level fitment (2026-09-13) ----
  // The tile gate in cpbEvaluateGates used to be product-level only: a tile
  // survived if ANY variant fit, but the popup's `.acc-variant-item-inner`
  // mirrors kept Liquid's forloop.first `.selected`, so one-click SELECT
  // always added variant #1 (an F450 truck got the F250 shocks). These two
  // PURE helpers pick the variant to seat + decide popup <option> visibility
  // with the SAME matchesPartial semantics as updateOptionVisibility /
  // cpbFittingValues (null earlier answer = unconstrained). Mirrored in
  // test/accessory-variant-fitment.test.js — keep them in sync.
  //
  // variants: [{ varid: '123', opts: ['F250/F350', '', ''] }] (positional
  // option1..3, '' when the product has no such option).
  function cpbPickAccessoryVariant(variants, currentVarid, fits) {
    var first = null;
    for (var i = 0; i < variants.length; i++) {
      if (!fits(variants[i].varid)) continue;
      if (variants[i].varid === currentVarid) return currentVarid;
      if (first === null) first = variants[i].varid;
    }
    return first;
  }
  function cpbAccessoryOptionFits(variants, index, value, selectedOptions, fits) {
    var test = selectedOptions.slice();
    test[index] = value;
    return variants.some(function (v) {
      for (var i = 0; i <= index; i++) {
        if (test[i] && String(v.opts[i] || '') != test[i]) return false;
      }
      return fits(v.varid);
    });
  }
  // DOM readers/writers for the helpers above. Seating goes THROUGH the
  // popup's own `.accessories-popup-select` change handler (set the selects,
  // trigger change) — that handler is the one place that re-seats the
  // mirror AND copies data-basesku/data-baseprice/images/data-selectedprice
  // onto the tile, so the ATC composer (reads `.acc-variant-item-inner
  // .selected`) can never desync from what the tile displays. Never move
  // `.selected` on a mirror by hand (see the D7 note in cpbEvaluateGates).
  function cpbAccessoryMirrors($popup) {
    return $popup.find('.acc-variant-item-inner[data-varid]').toArray().map(function (el) {
      return {
        varid: String(el.getAttribute('data-varid')),
        opts: [1, 2, 3].map(function (i) { return String(el.getAttribute('data-option' + i) || ''); }),
      };
    });
  }
  function cpbSeatAccessoryVariant($popup, variants, varid) {
    var v = variants.filter(function (x) { return x.varid === varid; })[0];
    var $selects = $popup.find('select.variant-options');
    if (!v || !$selects.length) return false;
    // Clear a previous filter pass first: jQuery's select .val() GETTER skips
    // disabled <option>s, so the change handler below would read null for a
    // value cpbFilterAccessoryOptions disabled under the PREVIOUS vehicle and
    // never re-seat (caught live 2026-09-13). The filter re-applies after.
    $selects.find('option').prop({ hidden: false, disabled: false });
    $selects.each(function () {
      var idx = parseInt(this.getAttribute('data-option-index'), 10) || 1;
      $(this).val(v.opts[idx - 1]);
    });
    $selects.last().trigger('change');
    return true;
  }
  // Hide (and disable — iOS Safari ignores `hidden` on <option>) values with
  // no fitting variant given the earlier selects. No vehicle, or the dealer
  // "show non-fitting" toggle, = everything stays reachable (never remove
  // access — Ben 2026-07-20).
  // mirrored in test/accessory-variant-fitment.test.js — keep identical
  function cpbReachableOptionCount(options) {
    var n = 0;
    for (var i = 0; i < (options ? options.length : 0); i++) {
      if (!options[i].hidden && !options[i].disabled) n++;
    }
    return n;
  }
  function cpbFilterAccessoryOptions($popup, variants, fits, hasVehicle) {
    var $selects = $popup.find('select.variant-options');
    if (!$selects.length) return;
    var selected = [];
    $selects.each(function () {
      var idx = (parseInt(this.getAttribute('data-option-index'), 10) || 1) - 1;
      selected[idx] = this.value ? String(this.value) : null;
    });
    var showAll = !hasVehicle || !!window.__builderShowNonFitting;
    $selects.each(function () {
      var idx = (parseInt(this.getAttribute('data-option-index'), 10) || 1) - 1;
      $(this).find('option').each(function () {
        var ok = showAll || cpbAccessoryOptionFits(variants, idx, String(this.value), selected, fits);
        this.hidden = !ok;
        this.disabled = !ok;
      });
    });
  }

  // ---- Installation guide ATC property ----
  // Resolves the vehicle-matched guide URL from the [data-ig-product-guides]
  // blob (sections/custom-product-build.liquid) using the same gidTail match
  // as assets/install-guide-product.js's resolveGuide() contract. Reuses
  // getVehicleSelection()/gidId() above. Absolute URL (order/QR/email need
  // it). Returns null only when the blob is absent — callers must omit the
  // _install_guide property entirely in that case (never submit empty).
  function resolveInstallGuideUrl() {
    var blobEl = document.querySelector('script[data-ig-product-guides]');
    if (!blobEl) return null;
    var guides;
    try { guides = JSON.parse(blobEl.textContent || '[]'); } catch (e) { return null; }
    if (!Array.isArray(guides) || !guides.length) return null;

    var sel = getVehicleSelection();
    var tail = sel ? gidId(sel.filter_value) : null;
    var match = null;
    if (tail) {
      for (var i = 0; i < guides.length; i++) {
        var gens = guides[i].gens || [];
        if (!gens.length || gens.map(gidId).indexOf(tail) !== -1) { match = guides[i]; break; }
      }
    }
    if (!match && guides.length === 1) match = guides[0];

    if (match && match.url) return window.location.origin + match.url;
    var handle = blobEl.getAttribute('data-product-handle') || '';
    return window.location.origin + '/pages/install-guides?product=' + handle;
  }

  if (!customElements.get("custom-build-product")) {
    customElements.define(
      "custom-build-product",
      class CustomBuildProduct extends HTMLElement {  
        constructor() {
          super();

          var this2 = this;
          window.__cpbInstance = this2;
          this.initSteps();

           
          this.updateAllBoxPrices();
         
          this.initAccesoriesPopup();
           document.addEventListener("initCanvas", () => {
            this2.initCanvas();
            this2.updateAllBoxPrices();
          });
          document.addEventListener("initAccessoriesCanvas", () => {
            this2.initAccesoriesPopup();
          });
          document.addEventListener("initSummary", () => {
            this2.setSelectionSummary();
          });
          document.addEventListener("vehicle:selection:updated", () => {
            __fitCache = {};
            this2.updateOptionVisibility();
            // cpbEvaluateGates is assigned inside initSteps() (called above,
            // synchronously, before this listener is registered) -- P2-C.
            this2.cpbEvaluateGates();
          });
          // Task 7: prereq re-resolution. Registered AFTER the listener above
          // so __fitCache is already cleared + option visibility refreshed
          // before cpbFittingValues() reads variantFitsVehicle for the new
          // selection. Reconciles applied prereqs silently (no Next click).
          document.addEventListener("vehicle:selection:updated", () => {
            this2.cpbRunPrereqResolution();
          });

          $(document).on(
            "click",
            ".custom-product-content-step.option-steps .value-item",
            function (e) {
              

              
              this2.updateOptionVisibility();
              this2.updateCustomBuildProductAttrs();
              // Base-variant re-seat is a first-class gate trigger (D12) --
              // a set gated on the default variant must hide the moment the
              // user switches away from it. Idempotent, no guard needed.
              this2.cpbEvaluateGates();
              // Re-validate applied prereqs against the just-changed earlier
              // option: an earlier-axis change can make a silently-applied
              // lookup value resolve to a different value, or stop resolving
              // (then the target step un-hides so the buyer SEES it). Reconcile
              // machine handles noop/reapply/release. Guarded so an in-progress
              // apply (which drives radios via .prop, not .click) can't re-enter.
              if (!window.__cpbPrereqApplying) this2.cpbRunPrereqResolution();
              if (window.__cpbPrereqApplying) return;
              var curKey = ($('.custom-product-content-step.current').attr('data-step-key') || '');
              var cfg = this2.cpbStepCfg(curKey);
              var legacyAdvance = $('custom-build-product').attr('data-protype') == 'custom';
              if (cpbEffectiveAutoAdvance(cfg, legacyAdvance)) {
                var isValid = true;
                $('.personalize-wrap-main:visible .personalize-input').each(function () {
                  if ($.trim($(this).val()) === "") {
                    isValid = false;

                  } else {

                  }
                });

                if (!isValid) {

                }else{
                  $(".nextbutton").click();
                }
              }
              // (legacy scroll-to-card animate on option click removed — Ben
              // round-3: no scroll-jacking inside the builder, any trigger)
            }
          );

         
          this.setSavedData();
          this.updateOptionVisibility(); // apply the vehicle-fitment filter on initial load
          if (document.querySelector(".cpb-step-visual[data-mode='variant']")) {
            window.__cpbPrereqApplying = true; // suppress text-picker + auto-advance during init sync
            try { this.updateCustomBuildProductAttrs(); } finally { window.__cpbPrereqApplying = false; }
          }
          //$('#fullPageLoader').hide()
           
        }   
        

        initSteps() {
          var this2 = this;

          // Per-step visual/advance/prereq config (spec 2026-07-23). Keys normalized.
          window.__cpbStepConfig = (function () {
            var el = document.querySelector('script[data-cpb-step-config]');
            if (!el) return { steps: {}, attrs: {} };
            try {
              var raw = JSON.parse(el.textContent);
              var steps = {};
              Object.keys(raw.steps || {}).forEach(function (k) { steps[cpbNormValue(k)] = raw.steps[k]; });
              return { steps: steps, attrs: raw.attrs || {} };
            } catch (e) { return { steps: {}, attrs: {} }; }
          })();
          this.cpbStepCfg = function (key) { return window.__cpbStepConfig.steps[cpbNormValue(key)] || null; };

          $(".custom-variant-wrapper .close-btn").on("click", function () {
            $(this).closest(".modal-overlay").removeClass("active");
          });
          $('.custom-color-checkbox').change(function(){
            $('.error-msg').remove();
            const infocontentsteps = document.querySelectorAll(".custom-product-content-step"); 
            if ($(infocontentsteps).hasClass("summary")) {
               $(".custom-build-product-footer").find(".btn-wrapper").addClass('btn-wrapper-checkout');
               if ($(".custom-color-checkbox").is(":checked") == false) {
                $(".nextbutton").css({"display":"none"});
                $(".button-checkout-main").css({"display":"none"});
               }else{
                $(".nextbutton").css({"display":"flex"}); 
                $(".button-checkout-main").css({"display":"flex"});
               }  
            }else{
              $(".custom-build-product-footer").find(".btn-wrapper").removeClass('btn-wrapper-checkout');
              $(".nextbutton").css({"display":"flex"}); 
            }
          })    

          $(".custom-variant-wrapper .modal-overlay").on("click", function (e) {
            if (e.target === this) {
              $(this).removeClass("active");
            }
          });  

          function updateProgressbarTitle($builder) {
            var btnText = $builder
              .find(".custom-product-step.current .custom-button-text")
              .text()
              .trim();
            $builder
              .find(".progressbar-title .text[data-pro-text]")
              .attr("data-pro-text", btnText)
              .text(btnText);
          }

          $(".custom-product-builder").each(function () {
            updateProgressbarTitle($(this));

            const builder = this;
            const stepsContainer = $(builder)
              .find(".custom-product-step")
              .parent()[0];

            if (!stepsContainer) return;

            const observer = new MutationObserver(function () {
              updateProgressbarTitle($(builder));
            });

            observer.observe(stepsContainer, {
              subtree: true,
              attributes: true,
              attributeFilter: ["class"],
            });
          });
  
          const slider = document.getElementById("productSlider");
          const nextBtn = slider.querySelector(".nextbutton");
          const backBtn = slider.querySelector(".backbutton");
          const resetBtn = slider.querySelector("button[type='reset']");
          const stepsContainer = document.querySelector(
            ".custom-product-builder-steps"
          );
          const contentstepsContainer = document.querySelector(
            ".custom-product-builder-steps"
          );

          // Canonical pairing: rail[i] <-> panel[i] (see cpbVisibleIndices comment).
          function stepPairs() {
            const rails = document.querySelectorAll(".custom-product-step");
            const panels = document.querySelectorAll(".custom-product-content-step");
            return Array.prototype.map.call(rails, function (rail, i) {
              return { rail: rail, panel: panels[i] };
            });
          }

          function visibleSteps() {
            const all = stepPairs();
            return cpbVisibleIndices(all.map(function (s) { return !!s.rail.hidden; }))
              .map(function (i) { return all[i]; });
          }

          // Returns true iff this call actually changed rail or panel
          // `hidden` (checked independently -- they could in principle be
          // server-rendered out of step with each other). Callers use this
          // to detect a true no-op pass (see cpbEvaluateGates's anyFlipped).
          function setStepHidden(pair, hide) {
            hide = !!hide;
            var flipped = pair.rail.hidden !== hide || (pair.panel && pair.panel.hidden !== hide);
            pair.rail.hidden = hide;
            if (pair.panel) pair.panel.hidden = hide;
            return flipped;
          }

          // Single entry point after any visibility change. Phase 2 sets
          // `hidden` on pairs, then calls this.
          // MUST NOT call updateSliderVars(): that scroll-jacks the page and
          // writes localStorage (:387-402). Ben rejected scroll-jacking twice.
          // DERIVES `active` from the DOM's `.current` class. To move the user,
          // move `.current` (or navigate) -- never assign `active` around this.
          // `active = X; cpbSyncSteps();` silently loses X while the current
          // rail is visible; assigning AFTER repaints nothing (updateStepClasses
          // is not exposed, updateSliderVars is forbidden above). A pre-set
          // `active` survives ONLY when the caller hid the current step --
          // then there is no anchor and cpbClampActive takes it.
          function cpbSyncSteps() {
            // Re-anchor to the step the user is actually ON before renumbering.
            // Clamping the raw `active` NUMBER drifts them forward when an
            // EARLIER step hides (rails [A,B,C,D], on B, hide A -> vis[1] is C,
            // not B). By the time we're called the caller has ALREADY set
            // `hidden` on the pair, so visibleSteps() here is the NEW
            // post-hide list -- the old one is not recoverable from it.
            // Instead find the rail the user was actually on via the
            // `.current` class: updateStepClasses() left it there on the
            // last sync, and toggling `hidden` does not clear classes, so it
            // survives the caller's mutation intact. If that rail is still
            // visible, re-anchor `active` to its new position. If the
            // caller just hid the current step itself, `.current`'s canonical
            // step won't be in `vis` -- leave `active` alone and let
            // updateStepClasses()'s existing cpbClampActive fallback pick the
            // nearest visible step (Phase 1's currentMigration invariant).
            const curRail = document.querySelector(".custom-product-step.current");
            const vis = visibleSteps();
            if (curRail) {
              const anchored = vis.findIndex(function (s) { return s.rail === curRail; });
              // count is re-derived from active in updateStepClasses() (:410)
              // on every path that reaches here -- no need to set it twice.
              if (anchored >= 0) { active = anchored + 1; }
            }
            vis.forEach(function (s, i) {
              const chip = s.rail.querySelector(".cpb-step-chip");
              if (chip) chip.textContent = String(i + 1);
            });
            repeat = vis.length;
            if (slider) slider.style.setProperty("--repeat", repeat);
            updateStepClasses();
            cpbSyncProgressBar();
          }
          this2.cpbSyncSteps = cpbSyncSteps;

          // ---- Conditional accessory-set gates (Phase 2 Task 5, D7/D8/D12) ----
          // Two independent gates per set, ANDed: fitment (>=1 tile survives
          // variantFitsVehicle) and required_products (empty list = pass; else
          // >=1 listed variant id -- base OR accessory -- currently selected).
          // OR within each gate's own list. D7 (updated 2026-09-13): the
          // .acc-variant-item-inner mirrors are NEVER re-seated BY HAND here
          // (that desyncs data-basesku/data-baseprice from the variant
          // actually added -> id: undefined at ATC -> /cart/add.js rejects the
          // WHOLE payload, silently). Variant-level seating instead sets the
          // popup selects and fires their own change handler
          // (cpbSeatAccessoryVariant), and popup <option>s are hidden via
          // cpbFilterAccessoryOptions. A hidden tile MUST drop .selected (D8) --
          // ten consumers key on that class and none checks visibility -- so a
          // RAM tile can't survive as "selected" once it's hidden from a GMC.
          // After any clear: syncAllAccessorySets() re-derives .locked (a
          // single-select set left with zero visible selections must unlock
          // its siblings) and updateAllBoxPrices() re-runs (footer total + the
          // $50 fee card only recompute from explicit call sites -- a class
          // removal alone leaves them stale). setStepHidden() runs per set;
          // cpbSyncSteps() runs ONCE after every set is decided, never per set.
          function cpbEvaluateGates(opts) {
            // D9 (Task 6): never evaluate before setSavedData()'s restore
            // callback has flipped this flag (see the settle point at the
            // end of that callback, both the "bundle found" and "no bundle"
            // branches). Before that point a logged-in customer's saved
            // selections may not exist in the DOM yet -- restore is async
            // there ($.ajax().done()) -- so evaluating here would hide a
            // required_products-gated step against an EMPTY selection set;
            // restore's later addClass('selected') then no-ops against the
            // now-hidden tile, and the pricesDirty persist below would write
            // that truncated state back over the customer's saved bundle.
            // Fail open: do nothing until settled. (Every existing call
            // site -- vehicle:selection:updated, the base-variant click
            // handler, accessory add/remove -- only ever fires after the
            // element is constructed and interactive, i.e. after this flag
            // is set on any realistic timing, but the guard is what makes
            // that a guarantee instead of a race.)
            if (!this2.cpbGatesReady) return;

            var sel = getVehicleSelection();
            var pricesDirty = false;

            // Tile-level fitment gate. Scope-unrestricted on purpose: this
            // covers accessory tiles inside `otheraccessories` sets AND the
            // plain (non-set) `custom-product-accessories` step -- D5's blob
            // covers both paths so neither silently "fits everything".
            // Variant-level (2026-09-13): the tile survives if ANY variant
            // fits (as before), and the SEATED variant is re-derived so
            // one-click SELECT adds one that fits — seat goes through the
            // popup change handler (cpbSeatAccessoryVariant), never by hand.
            $(".accessories-product[data-pid]").each(function () {
              var $tile = $(this);
              var pid = $tile.attr("data-pid");
              var $popup = $('.accessories-popup-overlay[data-pid="' + pid + '"]');
              var variants = cpbAccessoryMirrors($popup);
              var fits = function (varid) { return variantFitsVehicle(varid, sel); };
              var currentVarid = String($popup.find(".acc-variant-item-inner.selected[data-varid]").attr("data-varid") || "");
              var seat = cpbPickAccessoryVariant(variants, currentVarid, fits);
              var anyFits = seat !== null;
              $tile.prop("hidden", !anyFits);
              if (!anyFits && $tile.hasClass("selected")) {
                $tile.removeClass("selected").find(".selected_button").text("SELECT");
                pricesDirty = true;
              }
              if (anyFits && seat !== currentVarid && cpbSeatAccessoryVariant($popup, variants, seat)) {
                pricesDirty = true; // seated variant may carry a different price
              }
              cpbFilterAccessoryOptions($popup, variants, fits, !!sel);
            });

            // Selected variant ids = base selection UNION each currently-
            // selected tile's popup-mirrored selection (D12). Reading the
            // mirror divs is correct -- it is exactly what ATC does; only
            // hiding them would have been wrong (Trap 1).
            var selectedIds = [];
            $(".variant-item-inner.selected[data-varid]").each(function () {
              selectedIds.push(String($(this).attr("data-varid")));
            });
            $(".accessories-product.selected[data-pid]").each(function () {
              var pid = $(this).attr("data-pid");
              $('.accessories-popup-overlay[data-pid="' + pid + '"] .acc-variant-item-inner.selected[data-varid]').each(function () {
                selectedIds.push(String($(this).attr("data-varid")));
              });
            });

            // Per-set (= per `.other-accessories-step` panel, PLUS the plain
            // `.accessories-step` flat-list panel -- its wrapper carries the
            // same `.custom-product-variant-kit.accessories` shape and no
            // `data-required-variants`, so the selection gate passes
            // trivially and the fitment gate alone governs it here) composition.
            // The wrapper this render emits (product-accessories-other.liquid /
            // custom-product-accessories.liquid) lives INSIDE its own step's
            // panel (custom-product-build.liquid renders one rail + one panel
            // per set/step), so panel-node identity is the map back to
            // stepPairs() -- no id/index bookkeeping needed, no risk of the
            // fresh-object trap that bit Tasks 1/2 (stepPairs() is hoisted
            // once above this loop and matched by reference).
            var pairs = stepPairs();
            var anyFlipped = false;
            document.querySelectorAll(".custom-product-content-step.other-accessories-step, .custom-product-content-step.accessories-step").forEach(function (panel) {
              var setEl = panel.querySelector(".custom-product-variant-kit.accessories");
              if (!setEl) return;
              var anyTileFits = !!panel.querySelector(".accessories-product:not([hidden])");
              var triggers = String(setEl.getAttribute("data-required-variants") || "")
                .split(",")
                .map(function (s) { return s.trim(); })
                .filter(Boolean);
              var gatePasses = !triggers.length || triggers.some(function (t) { return selectedIds.indexOf(t) !== -1; });
              var stepHides = !(anyTileFits && gatePasses);
              // Trigger axis of D8: a set can hide because its OWN tiles
              // stopped fitting (anyTileFits false -- already handled by
              // the tile-level loop above, which drops .selected from any
              // tile it individually marks [hidden]) OR because its
              // required_products TRIGGER was de-selected elsewhere
              // (gatePasses false). The second case leaves every member
              // tile fitting and therefore NOT [hidden] -- they just sit
              // inside a panel that's about to hide -- so the tile-level
              // loop never touches them. Without this, a tile selected
              // while its trigger was active survives as .selected after
              // the trigger (and its step) is gone, and every one of the
              // ten .selected consumers (ATC, bundle-persist, footer, ...)
              // has no visibility filter -- it ships. Mirror the tile-level
              // clear exactly: same class removal, same .selected_button
              // reset, same pricesDirty flag -> same sync/persist path
              // below. Scope to tiles NOT already [hidden] -- those were
              // already cleared (or were never selected) above; touching
              // them again would be a harmless no-op, so this is purely to
              // avoid double-processing, not a correctness guard.
              if (stepHides) {
                panel.querySelectorAll(".accessories-product:not([hidden]).selected").forEach(function (tile) {
                  tile.classList.remove("selected");
                  var btn = tile.querySelector(".selected_button");
                  if (btn) btn.textContent = "SELECT";
                  pricesDirty = true;
                });
              }
              var pair = pairs.filter(function (p) { return p.panel === panel; })[0];
              if (pair) {
                if (setStepHidden(pair, stepHides)) anyFlipped = true;
              }
            });

            if (pricesDirty) {
              this2.syncAllAccessorySets();
              this2.updateAllBoxPrices();
              // D9/Hazard B (Task 6): a gate-driven clear must persist, or
              // the orphaned tile survives in the saved bundle and rides
              // back in on the next restore (e.g. a RAM part surviving a
              // vehicle change to a truck it doesn't fit, OR an overlay
              // surviving its 4-link trigger being de-selected). Safe to
              // call unconditionally here BECAUSE of the cpbGatesReady
              // guard above -- this line can only run once restore has
              // already settled, so the DOM (and therefore what gets
              // persisted) is always the real post-restore, post-gate
              // state, never a truncated in-flight one.
              //
              // EXCEPT the settle-point evaluation itself (opts.skipPersist):
              // that call is a pure side effect of PAGE LOAD, not a user
              // action. A customer who saved a build for truck A must not
              // have it silently stripped server-side just because they
              // loaded this page with truck B's cookie set (e.g. browsing
              // a different vehicle on another device/tab), and likewise a
              // trigger-gated tile from a previously-saved bundle must not
              // be stripped server-side just because THIS page load hasn't
              // re-selected the trigger yet. The DOM still gets correctly
              // gated either way -- only the write to storage is
              // suppressed, so the orphaned selection stays recoverable
              // until the customer's next real save, which is exactly when
              // dropping it is safe and intended.
              if (!opts || !opts.skipPersist) {
                this2.createAndSaveBundle();
              }
            }

            // No-op guard, SCOPED to the page-load settle call only (opts.
            // skipPersist -- that flag already means exactly "this is the
            // pure side-effect-of-load evaluation, not a user action", so
            // it doubles as the settle-call signal here rather than adding
            // a second flag). On a store with no gate data every set passes
            // trivially, anyFlipped stays false, and skipping cpbSyncSteps()
            // means updateStepClasses() never runs at load -- no orange
            // connector line, no initCanvas/color-inheritance side effect
            // on a class of product nobody has verified that on. Any real
            // flip (gate data present) still syncs. Every user-action call
            // site (vehicle change, accessory click/remove, base-variant
            // reseat) passes no opts, so `opts && opts.skipPersist` is
            // false there and this condition never applies -- those paths
            // sync unconditionally, exactly as Task 5 verified.
            if (opts && opts.skipPersist && !anyFlipped) return;

            cpbSyncSteps();
          }
          this2.cpbEvaluateGates = cpbEvaluateGates;

          let getCSSValue = (varName) =>
            parseInt(slider.style.getPropertyValue(varName)) || 1;

          // --repeat is the SERVER's step count and goes stale the moment a step
          // hides. Bounds now derive from visibleSteps(). Kept only so the inline
          // style stays truthful for any future reader; it has no CSS consumer
          // (.custom-product-builder-slider is display:none,
          // snippets/custom-product-build-style.liquid:370-372, and again at
          // :385 for the mobile media-query duplicate).
          let repeat = getCSSValue("--repeat");
          let count = getCSSValue("--count");
          let active = getCSSValue("--active");

          // Mobile progress bar: fill = current rail position (DOM truth — the
          // slider's active/count vars don't map 1:1 to visible steps)
          function cpbSyncProgressBar() {
            var pbEl = document.querySelector(".progressbar-title");
            if (!pbEl) return;
            var vis = visibleSteps();
            var curIdx = vis.findIndex(function (s) { return s.rail.classList.contains("current"); });
            var cur = curIdx >= 0 ? vis[curIdx].rail : null;
            var idx = curIdx + 1;
            if (vis.length && idx > 0) pbEl.style.setProperty("--pb", Math.min(100, Math.round((idx / vis.length) * 100)) + "%");
            var headEl = document.querySelector(".cpb-step-heading");
            if (headEl && cur) {
              // only where the card image sits above the options (native variant +
              // color steps) — set/accessory panels render their own title (Ben).
              // Panel comes from the PAIR, not a product-step attribute lookup.
              var curPanel = vis[curIdx].panel;
              var plainStep = curPanel && !curPanel.classList.contains("other-accessories-step") && !curPanel.classList.contains("accessories-step") && !curPanel.classList.contains("summary");
              headEl.textContent = plainStep ? (cur.querySelector(".custom-button-text") || cur).textContent.replace(/\*/g, "").trim() : "";
            }
            // fit chip on Summary: the product card is hidden there, so the slot
            // rides into the summary panel and returns home on other steps
            var slotEl = document.querySelector(".cpb-fitment-slot");
            if (slotEl && cur) {
              var isLast = curIdx === vis.length - 1;
              var summaryPanel = document.querySelector(".custom-product-content-step.summary");
              if (isLast && summaryPanel) {
                var host = summaryPanel.querySelector(".catalogue") || summaryPanel;
                if (slotEl.parentElement !== host) host.insertBefore(slotEl, host.firstChild);
                // the sticky footer floats over the tail of the page — pad the
                // summary by its real height so ATC clears it at max scroll
                var footEl = document.querySelector(".custom-build-product-footer");
                if (footEl) summaryPanel.style.paddingBottom = (footEl.offsetHeight + 28) + "px";
              } else {
                var home = document.querySelector(".custom-product-right");
                if (home && slotEl.parentElement !== home) home.insertBefore(slotEl, home.querySelector(".personalize-wrap-main"));
              }
            }
          }
          cpbSyncProgressBar();

          // no scroll on step change (Ben round-3: the animated scroll-to-builder
          // on Next/Back was worse than staying put — mobile app-frame doesn't
          // resize the page anyway, desktop keeps the user's scroll position)
          let updateSliderVars = () => {
            $('.error-msg').remove();
            slider.style.setProperty("--count", count);
            slider.style.setProperty("--active", active);
            updateStepClasses();
            cpbSyncProgressBar();
            // master-parity: the PAGE is the scroller — bring the builder's
            // top (the sticky band) back into view on every step change
            $("html, body").animate(
              {
                scrollTop: $("custom-build-product").offset().top,
              },
              200
            );
            this2.createAndSaveBundle();
          };

           $('.customization-input').change(function(){
             this2.createAndSaveBundle();
          })

          let updateStepClasses = () => {
            // Clear across ALL steps (hidden included) — a hidden step must not
            // keep a stale .current/.active for when it is shown again.
            stepPairs().forEach(function (s) {
              s.rail.classList.remove("current", "active");
              if (s.panel) s.panel.classList.remove("current");
            });

            const vis = visibleSteps();
            if (!vis.length) return;
            active = cpbClampActive(active, vis.length);
            count = active;

            // Everything below indexes the VISIBLE list, never raw DOM.
            const steps = vis.map(function (s) { return s.rail; });
            const contentsteps = vis.map(function (s) { return s.panel; });

            // Add classes as per active step
            steps.forEach((step, index) => { 
              step.classList.toggle("active", index < active);
              if (index === active - 1) {
                step.classList.add("current");
              }
            });

            contentsteps.forEach((contentstep, index) => {
              if (index === active - 1) {   
                contentstep.classList.add("current");
                if ($(contentstep).hasClass("color-options-step")) {
                  document.dispatchEvent(new Event("initCanvas"));
                }
                if ($(contentstep).hasClass("accessories-step") || $(contentstep).hasClass("other-accessories-step")) {
                  const primaryval = $("#primaryColorMain option:selected").attr("value") || "";
                  const secondaryval = $("#secondaryColorMain option:selected").attr("value") || "";
                  // catalog-injected powders (Mayan Orange etc.) aren't in popup selects —
                  // inherit them by injecting via the powder catalog instead of skipping
                  const primaryPowder = $("#primaryColorMain option:selected").attr("data-tso-powder") === "1";
                  const secondaryPowder = $("#secondaryColorMain option:selected").attr("data-tso-powder") === "1";
                  // carry the source option's tint hex: an inherited "Color Match" is the
                  // sentinel entry, whose catalog hex is meaningless — the main select's
                  // data-colorcode already holds the truck paint's hex (powder-search
                  // hexOverride). Display only; pricing rides the catalog entry.
                  const primaryHex = $("#primaryColorMain option:selected").attr("data-colorcode") || "";
                  const secondaryHex = $("#secondaryColorMain option:selected").attr("data-colorcode") || "";
                  $('.accessories-product').each(function () {
                    const pid = $(this).attr('data-pid');
                    const $popup = $('.accessories-popup-overlay[data-pid="' + pid + '"]');

                    // Primary
                    const $primarySelect1 = $popup.find('.accessories-popup-select.primary-colors');
                    if ($primarySelect1.find('option[value="' + primaryval + '"]').length) {
                      cpbSetSelect($primarySelect1, primaryval);
                    } else if (primaryPowder && $primarySelect1.length && window.TSOPowder) {
                      window.TSOPowder.injectByLabel($primarySelect1[0], primaryval, primaryHex);
                    }

                    const $primarySelect2 = $popup.find('.product-options.option-1 select');
                    if ($primarySelect2.find('option[value="' + primaryval + '"]').length) {
                      cpbSetSelect($primarySelect2, primaryval);
                    }

                    // Secondary
                    const $secondarySelect1 = $popup.find('.accessories-popup-select.secondary-colors');
                    if ($secondarySelect1.find('option[value="' + secondaryval + '"]').length) {
                      cpbSetSelect($secondarySelect1, secondaryval);
                    } else if (secondaryPowder && $secondarySelect1.length && window.TSOPowder) {
                      window.TSOPowder.injectByLabel($secondarySelect1[0], secondaryval, secondaryHex);
                    }

                    const $secondarySelect2 = $popup.find('.product-options.option-2 select');
                    if ($secondarySelect2.find('option[value="' + secondaryval + '"]').length) {
                      cpbSetSelect($secondarySelect2, secondaryval);
                    }
                  });
                  document.dispatchEvent(new Event("initAccessoriesCanvas"));
                }
                // index === 0 (first VISIBLE step) keeps the card too: a
                // no-variant product server-hides its "My Truck" option pair,
                // so the builder opens on colors/accessories — without this
                // the product identity (title/price/fitment chip) never shows.
                // Summary stays card-hidden (its own slot-relocation contract).
                if (($(contentstep).hasClass("option-steps") || $(contentstep).hasClass("prereq-step") || index === 0) && !$(contentstep).hasClass("summary")) {
                    $('.custom-options-product-card').show();
                }
                else{
                  $('.custom-options-product-card').hide();
                }
                // paint the current step's visual (or restore natural) into the card image
                cpbApplyCardVisual();
                if (
                  $(contentstep).hasClass("summary") ||
                  $(contentstep).hasClass("accessories-step")
                ) {
                                 
                }                     
                if ($(contentstep).hasClass("summary")) {
                  $(".custom-build-product-footer").find(".btn-wrapper").addClass('btn-wrapper-checkout');
                  if ($(".custom-color-checkbox").is(":checked") == false) {
                    $(".nextbutton").css({"display":"none"});
                    $(".button-checkout-main").css({"display":"none"});
                  }else{
                    $(".nextbutton").css({"display":"flex"}); 
                    $(".button-checkout-main").css({"display":"flex"});  
                  }
                  $(".next-text").html("CHECKOUT");
                  document.dispatchEvent(new Event("initSummary"));
                } else {
                  $(".custom-build-product-footer").find(".btn-wrapper").removeClass('btn-wrapper-checkout');
                  $(".next-text").html("NEXT");
                  $(".nextbutton").css({"display":"flex"}); 
                }
              }
            });
          };
 
          nextBtn.addEventListener("click", (e) => {
            $('.error-msg').remove();
            $('.accessory-set-required-error').remove();
            var $reqKit = $('.custom-product-content-step.current .custom-product-variant-kit[data-required="true"]');
            if ($reqKit.length && $reqKit.find('.accessories-product.selected').length === 0) {
              $reqKit.append('<div class="accessory-set-required-error">Please select an option to continue.</div>');
              return;
            }
            if (
              $(".option-steps.current").length > 0 &&
              $(".option-steps.current").find(".options-values").length > 0 &&
              $(".option-steps.current")
                .find(".options-values:visible")
                .find(".value-item:checked").length == 0
            ) {
              var $vopts = $(".option-steps.current .options-values:visible").last();
              var $errHost = $vopts.length ? $vopts : $(".custom-product-content-step.current");
              $errHost.after(`<div class="error-msg" style="
                  color: #c12a22;
                  font-size: 14px;
                  font-weight: 600;
                  text-align: center;
                  margin-top: 8px;
              ">Please select an option to continue.</div>`);
              return;
            } 
            
            var isValid = true;
            $('.personalize-wrap-main:visible .personalize-input').each(function () {
              if ($.trim($(this).val()) === "") {
                isValid = false;
                $(this).addClass('input-error'); 
              } else {
                $(this).removeClass('input-error');
              }
            });

            if (!isValid) {
              e.preventDefault(); 
              e.stopPropagation(); 
              var $firstErr = $('.personalize-wrap-main:visible .personalize-input.input-error').first();
              ($firstErr.closest('.personalize-wrap-main').length ? $firstErr.closest('.personalize-wrap-main') : $('.personalize-wrap-main:visible').last())
                .after(`<div class="error-msg" style="
                    color: #c12a22;
                    font-size: 14px;
                    font-weight: 600;
                    margin-top: 6px;
                ">Please enter all required personalization fields.</div>`);
              if ($firstErr.length) $firstErr.trigger('focus');
              return false;
            }
                      
            if (count < visibleSteps().length) {
              count++;
              active++;
              updateSliderVars();
            } else {
              if($('.custom-color-checkbox-wrapper').hasClass('disabled') == false){
                if ($(".custom-color-checkbox").is(":checked") == false) {
                  $(".custom-color-checkbox-wrapper")
                    .after(`<div class="error-msg" style="
                        color: red;
                        font-size: 14px;
                        text-align:center;
                        margin-top: 5px;
                    ">Please select the above checkbox to proceed.</div>`);
                    $(".custom-color-checkbox").focus()
                  return;
                }
              }
              $(".nextbutton").prop("disabled", true);
              var originalText = $(".nextbutton").html();
              $(".nextbutton").html(
                '<span class="spinner-add-to-cart"></span>'
              );
              this2.addAllProductsToCart();
             // window.location.href = '/checkout';
            }
          }); 

          backBtn.addEventListener("click", () => {
            if (count > 1) {
              count--;
              active = Math.max(1, active - 1);
              updateSliderVars();
            }
          });

          resetBtn.addEventListener("click", () => {
            const confirmReset = confirm("Are you sure you want to completely reset the form?\nEverything you've entered so far will be erased!");

            if (confirmReset) {
              count = 1;
              active = 1;
              updateSliderVars();
              window.BundleManager.deleteBundleByProductId(currentProductId);
              // master-parity: land back where the buyer was after the reload
              localStorage.setItem('scrollToPosition', window.scrollY);
              window.location.reload();

            } else {
              e.preventDefault(); // do nothing if cancelled
            }
            
          });

          $('.continue-link-checkout').click(function(e){
            e.preventDefault();
            if($('.custom-color-checkbox-wrapper').hasClass('disabled') == false){
                if ($(".custom-color-checkbox").is(":checked") == false) {
                  $(".custom-color-checkbox-wrapper")
                    .after(`<div class="error-msg" style="
                        color: red;
                        font-size: 14px;
                        text-align:center;
                        margin-top: 5px;
                    ">Please select the above checkbox to proceed.</div>`);
                    $(".custom-color-checkbox").focus()
                  return;
                }
              }
              $(".continue-link-checkout").prop("disabled", true);
              var originalText = $(".continue-link-checkout").html();
              $(".continue-link-checkout").html(
                '<span class="spinner-add-to-cart"></span>'
              );
              this2.addAllProductsToCart("/cart");

          })

          

          $(".custom-product-step").click(function () {
            // Position in the VISIBLE list — never the product-step attribute,
            // which is a static Liquid literal and goes stale when a step hides.
            const railEl = this;
            const idx = visibleSteps().findIndex(function (s) { return s.rail === railEl; });
            if (idx < 0) return; // hidden chip: not navigable
            count = idx + 1;
            active = idx + 1;
            updateSliderVars();
          });

          $(document).on('input', '.personalize-input', function () {
            var filtered = $(this).val().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u2018\u2019]/g, "'").replace(/[^a-zA-Z0-9@#$&\-_.!?/%']/g, '');
            if (filtered !== $(this).val()) {
              $(this).val(filtered);
            }
            var $wrap = $(this).closest('.personalize-wrap-main');
            var max = $(this).attr('maxlength');
            var current = $(this).val().length;
            var left = max - current;
            $(this).removeClass('input-error');
            $wrap.find('.personalize-count').text(left + ' characters left');
            this2.createAndSaveBundle()
          });

          $(document).on('click', '.qty-plus', function () {
            var $input = $(this).siblings('.qty-input');
            var val = parseInt($input.val()) || 1;
            if (val < 99) $input.val(val + 1);
            this2.updateAllBoxPrices();
          });

          $(document).on('click', '.qty-minus', function () {
            var $input = $(this).siblings('.qty-input');
            var val = parseInt($input.val()) || 1;
            if (val > 1) {
              $input.val(val - 1);
            } else {
              var $card = $(this).closest('.acc-product-card');
              var accPid = $card.attr('data-acc-pid');
              if (accPid) {
                $(`.custom-product-variant-item.accessories-product.selected[data-pid="${accPid}"]`).removeClass('selected');
                // qty-to-zero is an accessory selection change — a required_products
                // gate keyed on this variant must re-evaluate.
                this2.cpbEvaluateGates();
              }
              $card.remove();
            }
            this2.updateAllBoxPrices();
          });

          $(document).on('change', '.qty-input', function () {
            var val = parseInt($(this).val());
            if (isNaN(val) || val < 0) val = 1;
            if (val === 0) {
              var $card = $(this).closest('.acc-product-card');
              var accPid = $card.attr('data-acc-pid');
              if (accPid) {
                $(`.custom-product-variant-item.accessories-product.selected[data-pid="${accPid}"]`).removeClass('selected');
                this2.cpbEvaluateGates();
              }
              $card.remove();
              this2.updateAllBoxPrices();
              return;
            }
            if (val > 99) val = 99;
            $(this).val(val);
            this2.updateAllBoxPrices();
          });

          document.addEventListener("setCurrentStep", (e) => {
            // e.detail.step is a CANONICAL index — the same coordinate
            // createAndSaveBundle persists as `current_step` (1-based over ALL
            // panels, hidden included). `active` is a VISIBLE-list index, so
            // convert. Round-tripping the two without this lands on the wrong
            // step the moment anything hides.
            // stepPairs() allocates fresh objects every call, so match by rail
            // node identity -- never by pair object reference (Task 1's trap).
            const pair = stepPairs()[Number(e.detail.step) - 1];
            const idx = pair
              ? visibleSteps().findIndex(function (s) { return s.rail === pair.rail; })
              : -1;
            if (idx < 0) return; // no such step, or it's hidden: not navigable
            count = idx + 1;
            active = idx + 1;
            updateSliderVars();
          });

          $(document).on('click', '#builder-fitment-toggle', function () {
            window.__builderShowNonFitting = !window.__builderShowNonFitting;
            $(this).text(window.__builderShowNonFitting ? "Hide options that don't fit" : "Show options that don't fit");
            this2.updateOptionVisibility();
          });

          // ---- Prereq engine: answer click (Task 7) ----
          // NEVER .click() a radio, never assign `active`, never .remove() a
          // step (SHELL CONTRACT). Apply via prop('checked') + explicit trio,
          // hide/show via .hidden on rail+panel + cpbSyncSteps(), advance via
          // a single $('.nextbutton').click().
          $(document).on('click', '.cpb-prereq-answer', function () {
            // Money-path fail-safe: any error degrades to the stock builder
            // (all steps visible, no advance) via cpbFailSafe — never rethrows,
            // never advances on the error path.
            try {
              var panel = $(this).closest('.prereq-step')[0];
              var pre = this2.cpbPrereqCfg(panel);
              if (!pre) return;
              $(panel).find('.cpb-prereq-answer').removeClass('selected');
              $(this).addClass('selected');
              var which = $(this).attr('data-answer') === '1' ? pre.a1 : pre.a2;
              var res = cpbResolveAnswer(which, getVehicleSelection(), window.__cpbStepConfig.attrs,
                this2.cpbOptionValues(panel), this2.cpbFittingValues(panel));
              var tgtPair = this2.cpbTargetPair(panel);
              if (res.ok) {
                this2.cpbApplyPrereqValue(panel, res.value, true);
              } else {
                // "open the step" (or a dead answer): un-hide target, clear applied, advance into it
                window.__cpbPrereqApplying = true;
                try {
                  this2.cpbSetPairHidden(tgtPair, false);
                  panel.removeAttribute('data-cpb-applied');
                  document.querySelector('custom-build-product').cpbSyncSteps();
                } finally { window.__cpbPrereqApplying = false; }
                $('.nextbutton').click();
              }
            } catch (err) {
              cpbFailSafe(err);
            }
          });
        }

        // ---- Prereq engine helpers (Task 7) ----
        cpbPrereqPanels() { return $('.prereq-step').toArray(); }

        // rail+panel for a data-step-key (stepPairs zips by DOM order, so find index by panel)
        cpbPairForPanel(panel) {
          var panels = document.querySelectorAll('.custom-product-content-step');
          var i = Array.prototype.indexOf.call(panels, panel);
          return { rail: document.querySelectorAll('.custom-product-step')[i], panel: panel, index: i };
        }

        cpbTargetPair(prereqPanel) {
          var key = prereqPanel.getAttribute('data-target-key');
          var panel = $('.custom-product-content-step.option-steps').toArray().find(function (p) {
            return cpbNormValue(p.getAttribute('data-step-key')) === cpbNormValue(key);
          });
          return panel ? this.cpbPairForPanel(panel) : null;
        }

        cpbSetPairHidden(pair, hide) {
          if (!pair || !pair.rail || !pair.panel) return;
          pair.rail.hidden = hide;
          pair.panel.hidden = hide;
          // Stamp ONLY target pairs the prereq layer hides, so cpbFailSafe can
          // un-hide exactly those. Prereq pairs (.prereq-step panel) are exempt
          // — the fail-safe hides them wholesale, so they need no marker.
          if (!pair.panel.classList.contains('prereq-step')) {
            if (hide) {
              pair.rail.setAttribute('data-cpb-hidden-by-prereq', '');
              pair.panel.setAttribute('data-cpb-hidden-by-prereq', '');
            } else {
              pair.rail.removeAttribute('data-cpb-hidden-by-prereq');
              pair.panel.removeAttribute('data-cpb-hidden-by-prereq');
            }
          }
        }

        // Values of the target option carried by >=1 fitting variant, given the
        // buyer's already-checked EARLIER options. MUST mirror
        // updateOptionVisibility's matchesPartial semantics — asymmetry lets a
        // factory auto-pick land a non-fitting combo behind a hidden step.
        // (null = no vehicle; [] = nothing fits)
        cpbFittingValues(prereqPanel) {
          var sel = getVehicleSelection();
          if (!sel) return null;
          var pair = this.cpbTargetPair(prereqPanel);
          if (!pair) return null;
          var targetIndex = $('.option-steps').toArray().indexOf(pair.panel); // option position (0-based)
          // Checked earlier selections, positional over .option-steps — the same
          // source updateOptionVisibility reads (null = unanswered = unconstrained).
          var selectedOptions = [];
          $('.option-steps').each(function () {
            var val = $(this).find('input[type="radio"]:checked').val();
            selectedOptions.push(val !== undefined ? String(val) : null);
          });
          var out = [];
          $('.variant-item-inner').each(function () {
            var $el = $(this);
            var candidate = String($el.data('option' + (targetIndex + 1)) || '');
            if (!candidate || out.indexOf(candidate) !== -1) return;
            if (!variantFitsVehicle(String($el.attr('data-varid')), sel)) return;
            // This variant fits AND carries `candidate` at the target position;
            // require it to also match every CHECKED earlier selection
            // (positions 0..targetIndex-1; null selections unconstrained, same
            // guard as matchesPartial's `if (testOptions[i] && ...)`).
            var ok = true;
            for (var i = 0; i < targetIndex; i++) {
              if (selectedOptions[i] && String($el.data('option' + (i + 1))) != selectedOptions[i]) { ok = false; break; }
            }
            if (ok) out.push(candidate);
          });
          return out;
        }

        cpbOptionValues(prereqPanel) {
          var pair = this.cpbTargetPair(prereqPanel);
          if (!pair) return [];
          return $(pair.panel).find('.value-item').toArray().map(function (el) { return el.value; });
        }

        cpbPrereqCfg(prereqPanel) {
          var cfg = this.cpbStepCfg(prereqPanel.getAttribute('data-target-key'));
          return cfg && cfg.prereq ? cfg.prereq : null;
        }

        // Resolution pass — runs at init (after setSavedData restore) and on
        // every vehicle:selection:updated. Fail-open: an unresolvable lookup
        // hides the prereq AND un-hides the target (never both hidden).
        cpbRunPrereqResolution() {
          // Money-path fail-safe: any error degrades to the stock builder via
          // cpbFailSafe (all option steps visible, no applying flag) — never
          // rethrows, so the rest of init/sync survives.
          try {
            var this2 = this;
            var changed = false;
            this.cpbPrereqPanels().forEach(function (panel) {
              var pre = this2.cpbPrereqCfg(panel);
              if (!pre) return;
              var cookie = getVehicleSelection();
              var res = cpbResolveAnswer(pre.a1, cookie, window.__cpbStepConfig.attrs,
                this2.cpbOptionValues(panel), this2.cpbFittingValues(panel));
              var hasLookup = !!cpbParseLookup(pre.a1 && pre.a1.lookup);
              var applied = panel.getAttribute('data-cpb-applied');
              var action = cpbReconcile(applied, res);
              var prePair = this2.cpbPairForPanel(panel);
              var tgtPair = this2.cpbTargetPair(panel);
              // prePair.rail can be missing if rail/panel pairing is violated
              // (Task 7 review); guard the deref, tgtPair already guarded.
              if (action === 'release') {
                // unresolvable: lookup prereqs hide; target ALWAYS visible; applied state cleared
                if (hasLookup && prePair && prePair.rail) { if (!prePair.rail.hidden) changed = true; this2.cpbSetPairHidden(prePair, true); }
                if (tgtPair && tgtPair.rail && tgtPair.rail.hidden) { this2.cpbSetPairHidden(tgtPair, false); changed = true; }
                if (applied != null) { panel.removeAttribute('data-cpb-applied'); }
              } else {
                // resolvable: prereq visible
                if (prePair && prePair.rail && prePair.rail.hidden) { this2.cpbSetPairHidden(prePair, false); changed = true; }
                if (action === 'reapply') this2.cpbApplyPrereqValue(panel, res.value, false);
              }
            });
            if (changed) document.querySelector('custom-build-product').cpbSyncSteps();
          } catch (err) {
            cpbFailSafe(err);
          }
        }

        // Apply path — fromUser distinguishes advance. Applies the resolved
        // value to the target option (prop('checked') + explicit trio under
        // __cpbPrereqApplying), hides the target, records applied state, and
        // (fromUser only) issues one Next click.
        cpbApplyPrereqValue(panel, value, fromUser) {
          var this2 = this;
          var tgtPair = this.cpbTargetPair(panel);
          if (!tgtPair) return;
          // Money-path fail-safe: on error, cpbFailSafe restores the stock
          // builder (target un-hidden, flag cleared) and we do NOT advance —
          // the user stays on the native step and navigates manually.
          var ok = false;
          window.__cpbPrereqApplying = true;
          try {
            var norm = cpbNormValue(value);
            $(tgtPair.panel).find('.value-item').each(function () {
              if (cpbNormValue(this.value) === norm) $(this).prop('checked', true);
            });
            this2.updateOptionVisibility();
            this2.updateCustomBuildProductAttrs();
            this2.cpbEvaluateGates();
            this2.cpbSetPairHidden(tgtPair, true);
            panel.setAttribute('data-cpb-applied', String(value));
            document.querySelector('custom-build-product').cpbSyncSteps();
            ok = true;
          } catch (err) {
            cpbFailSafe(err);
          } finally { window.__cpbPrereqApplying = false; }
          if (ok && fromUser) $('.nextbutton').click();
        }

        updateCustomBuildProductAttrs() {
          let selectedOptions = [];
          $(".option-steps").each(function () {
            let val = $(this).find('input[type="radio"]:checked').val();  
            if (val !== undefined) selectedOptions.push(val);
          }); 
             

          let match = null;
          $(".variant-item-inner").each(function () {
            let $el = $(this);
            let isMatch = true;
            for (let i = 1; i <= selectedOptions.length; i++) {
              let optVal = $el.data("option" + i) || "";
              if (optVal != selectedOptions[i - 1]) {
                isMatch = false;
                break;
              }
            }
            if (isMatch) {
              match = $el;
              return false;
            }
          });
          if (match) {
            $(".variant-item-inner").removeClass("selected");
            match.addClass("selected");
            // stamp the card's natural src (variant image) — do NOT write it to
            // the visible src directly; cpbApplyCardVisual decides whether the
            // card shows this natural image or the current step's visual override.
            var $cardImg = $(".custom-options-product-card .custom-product-left").find("img");
            $cardImg.attr("data-cpb-natural-src", match.attr("data-varimage"));
            $cardImg.attr("data-cpb-natural-srcset", ""); // variant image is single-res
            // variant-mode panel visuals mirror the selected variant image
            $(".cpb-step-visual[data-mode='variant'] img").attr("src", match.attr("data-varimage"));
            cpbApplyCardVisual(); // natural stamped + variant visual updated → repaint card
            var sideEl = $("custom-build-product"), sideBase = Number(match.attr("data-baseprice"));
            $(".custom-product-price").html(cpbPromoPrice(sideBase, sideEl) < sideBase ? cpbPriceHtml(sideBase, sideEl, true) : match.attr("data-price"));
            var textboxcount = Number(match.attr('data-textboxcount'));
            $('.personalize-wrap-main').hide(); 
            $('.personalize-wrap-main').removeClass('active'); 
            $('.personalize-wrap-main').find('.personalize-input').attr('maxlength',match.attr('data-textcharlimit'));
            $('.personalize-wrap-main').find('.personalize-count').html(match.attr('data-textcharlimit') + ' characters left');
            for (let index = 1; index <= textboxcount; index++) {
              $('.personalize-wrap-main[data-row="'+index+'"]').show();
              $('.personalize-wrap-main[data-row="'+index+'"]').addClass('active');
            }

            var textKey = textboxcount > 0 ? selectedOptions.join('') : '';
            if (textKey !== this._lastTextKey) {
              this._lastTextKey = textKey;
              if (textboxcount > 0 && !window.__cpbRestoring && !window.__cpbTextApplying && !window.__cpbPrereqApplying && window.TSOTextPicker) {
                var rootEl = document.querySelector('custom-build-product');
                var blockEl = document.querySelector('.personalize-wrap-main[data-row="1"]').parentNode;
                window.TSOTextPicker.open({
                  root: rootEl,
                  block: blockEl,
                  doubleCapable: rootEl.getAttribute('data-double-capable') === 'true',
                  surface: 'main'
                });
              } else if (window.TSOTextPicker) {
                window.TSOTextPicker.closePanel();
              }
            }

            if ($("custom-build-product").attr("data-protype") == "custom") {
              $("#primaryColorMain option").attr(
                "data-basesku",
                match.attr("data-basesku")
              );
              $("#secondaryColorMain option").attr(
                "data-basesku",
                match.attr("data-basesku")
              );

              $("#primaryColorMain option").attr(
                "data-baseprice",
                match.attr("data-baseprice")
              );
              $("#secondaryColorMain option").attr(
                "data-baseprice",
                match.attr("data-baseprice")
              );
              let attrs = [
                "mainimage",
                "truckimage",
                "tipimage",
                "tippolishedimage",
                "overlayimage",
                "overlaypolishedimage",
                "screwimage",
              ];
              let $cbp = $("custom-build-product");
              attrs.forEach(function (attr) {
                let value = match.data(attr);
                if (typeof value !== "undefined") {
                  $cbp.attr("data-" + attr, value);
                }
              });
              this.updateAllBoxPrices();
              // Tile reprice signal. The colour tiles advertise +$ amounts that
              // are a PERCENTAGE of the selected variant's base price, but their
              // owners (cpb-color-tabs.js swatches/catalog, powder-search.js
              // match tiles) are separate files with no other way to know the
              // variant moved — without this they stay frozen at the price they
              // were rendered against (variants[0] server-side) while the chips
              // and footer, repriced by updateAllBoxPrices() above, move on.
              // Fired AFTER the option data-baseprice rewrite above so listeners
              // reading options[0] get the new base.
              document.dispatchEvent(
                new CustomEvent("cpb:variant:changed", {
                  detail: { basePrice: Number(match.attr("data-baseprice")) || 0 },
                })
              );
            }
          }
        }

        updateOptionVisibility() {
          const sel = getVehicleSelection();
          let variants = [];
          $(".variant-item-inner").each(function () {
            let $el = $(this);
            let options = [];
            let i = 1;
            while (typeof $el.data("option" + i) !== "undefined") {
              options.push(String($el.data("option" + i)));
              i++;
            }
            variants.push({ opts: options, varid: String($el.attr("data-varid")) });
          });

          let selectedOptions = [];
          $(".option-steps").each(function () {
            let val = $(this).find('input[type="radio"]:checked').val();
            selectedOptions.push(val !== undefined ? String(val) : null);
          });

          let anyNonFitting = false;

          $(".option-steps").each(function (stepIndex) {
            let $step = $(this);
            let checkedIsHidden = false;
            $step.find('input[type="radio"]').each(function () {
              let $radio = $(this);
              let value = String($radio.val());
              let testOptions = selectedOptions.slice();
              testOptions[stepIndex] = value;
              const matchesPartial = function (v) {
                for (let i = 0; i <= stepIndex; i++) {
                  if (testOptions[i] && v.opts[i] != testOptions[i]) return false;
                }
                return true;
              };
              let anyVariant = variants.some(matchesPartial);
              let fitsVariant = !sel
                ? anyVariant
                : variants.some(function (v) { return matchesPartial(v) && variantFitsVehicle(v.varid, sel); });
              if (sel && anyVariant && !fitsVariant) anyNonFitting = true;
              let $wrap = $radio.closest(".options-values");
              if (fitsVariant) {
                $wrap.show().removeClass("does-not-fit");
              } else if (window.__builderShowNonFitting && anyVariant) {
                $wrap.show().addClass("does-not-fit");
              } else {
                if ($radio.is(":checked")) checkedIsHidden = true;
                $wrap.hide().removeClass("does-not-fit");
              }
            });
          });

          // Toggle only appears when something is actually hidden by fitment.
          $('#builder-fitment-toggle').prop('hidden', !anyNonFitting);
        }
                 
        setSelectionSummary() {
          var addtocartdata = [];
          $(".acc-product-card").remove();
          var mainpr = $(".variant-item-inner.selected");
          var mainelem = $("custom-build-product");
          var personalizeHtml = "";

          $('.personalize-wrap-main.active .personalize-input').each(function () {
            var $wrap = $(this).closest('.personalize-wrap-main');
            var label = $wrap.find('.personalize-label').text().trim();
            var val   = $(this).val().trim();

            if (val !== "") {
              personalizeHtml += `<span><b>${label}:</b> <span class="tsoupdatefont">${val}</span></span>`;
            }
          });
          if ($("custom-build-product").attr("data-protype") == "custom") {
             var showCustom = false;
            $('#secondaryColorMain, #primaryColorMain').each(function() {
                var $opt = $(this).find("option:selected"); 
                if ($opt.data("colorcustom") === true || $opt.data("colorcustom") === "true") {
                    showCustom = true;
                }     
            }); 
            var customizenotes = ``;
            if($('.customization-input-main').val() != '' && showCustom == true){    
              customizenotes = ` <span><b>Customization Notes:</b> ${$('.customization-input-main').val()}</span>`;
            }
            var canvasPri = $("#primaryColorMain").find("option:selected");
            var canvasSec = $("#secondaryColorMain").find("option:selected");
            var cleanPrice = Math.round(mainelem.attr("data-totalprice"));
             var imageData = 'https://tso.co/cdn/shop/files/' +  mainelem.attr("data-selectedsku") + '.jpg';
            var fimageData = mainpr.attr("data-varimage");
            var vartitlestr = `<div class="acc-variant-title">${mainpr.attr(
              "data-vartitle"
            )}</div>`;  
            if (mainpr.attr("data-vartitle") == "Default Title") {
              vartitlestr = "";
            }
            $(".products-selected").append(`<div class="acc-product-card" data-card-type="main">
              <div class="acc-product-image">
                <img src="${imageData}" class="retry-image" alt="Product">
              </div>
              <div class="acc-product-details">
                <div class="acc-product-title">${mainelem.attr(
                  "data-title"
                )}</div>
                ${vartitlestr}
                <div class="acc-product-meta">
                  <span><b>SKU:</b> ${mainelem.attr("data-selectedsku")}</span>
                  <span><b>Primary Color:</b> ${canvasPri.attr("data-value")}</span>
                  <span><b>Secondary Color:</b> ${canvasSec.attr(
                    "data-value"
                  )}</span>
                   ${customizenotes}
                   ${personalizeHtml}
                </div>
                <div class="acc-product-price">
                  <span class="new-price">${cpbPriceHtml(cleanPrice, mainelem)}</span>
                </div>
                <div class="acc-product-actions">
                  <div class="quantity-selector">
                    <button type="button" class="qty-minus">−</button>
                    <input type="number" class="qty-input" value="1" min="1" max="99">
                    <button type="button" class="qty-plus">+</button>
                  </div>
                </div>
              </div>
            </div>`); 
            var item = {};
            item["id"] = mainpr.attr("data-varid");
            item["quantity"] = 1;  
            // item['properties'] = {
            //   ""
            // }      
            if(canvasPri.attr("data-termandcond") == "true" || canvasSec.attr("data-termandcond") == "true"){
                $('.custom-color-checkbox-wrapper').show();
                $('.custom-color-checkbox-wrapper').removeClass('disabled'); 
                if($('#custom-color-checkbox').is(':checked')){
                  $('.nextbutton').show();
                  $('.button-checkout-main').show();  
                }else{
                  $('.nextbutton').hide();
                   $('.button-checkout-main').hide();
                }
            }else{
              $('.custom-color-checkbox-wrapper').hide();
              $('.custom-color-checkbox-wrapper').addClass('disabled');
              $('.continue-link-checkout').show();
              $('.nextbutton').show();
              $('.button-checkout-main').show();
            } 
          } else {
            $(".products-selected").append(`<div class="acc-product-card" data-card-type="main">
              <div class="acc-product-image">
                <img src="${mainpr.attr("data-varimage")}" alt="Product">
              </div>
              <div class="acc-product-details">
                <div class="acc-product-title">${mainelem.attr(
                  "data-title"
                )}</div>
                <div class="acc-variant-title">${mainpr.attr(
                  "data-vartitle"
                )}</div>
                <div class="acc-product-meta">
                   ${personalizeHtml}
                </div>
                <div class="acc-product-price">
                  <span class="new-price">${cpbPriceHtml(Number(mainpr.attr("data-baseprice")), mainelem)}</span>
                </div>
                <div class="acc-product-actions">
                  <div class="quantity-selector">
                    <button type="button" class="qty-minus">−</button>
                    <input type="number" class="qty-input" value="1" min="1" max="99">
                    <button type="button" class="qty-plus">+</button>
                  </div>
                </div>
              </div>
            </div>`);
             $('.custom-color-checkbox-wrapper').hide();
              $('.custom-color-checkbox-wrapper').addClass('disabled');
              $('.continue-link-checkout').show();
              $('.nextbutton').show();
              $('.nextbutton').show();
          }

          if (
            $(".custom-product-variant-item.accessories-product.selected")
              .length > 0
          ) {
            $(".summary-section.accessories-selected").show();
            $(".custom-product-variant-item.accessories-product.selected").each(
              function () {
                const productId = $(this).data("pid");
                const $popup = $(
                  `.accessories-popup-overlay[data-pid='${productId}']`
                );
                 var showCustom = false;
                $popup.find('.primary-colors, .secondary-colors').each(function() {
                    var $opt = $(this).find("option:selected"); 
                    if ($opt.data("colorcustom") === true || $opt.data("colorcustom") === "true") {
                        showCustom = true;
                    } 
                }); 
                var customizenotes = ``;
                if($popup.find('.customization-input').val() != '' && showCustom == true){
                  customizenotes = ` <span><b>Customization Notes:</b> ${$popup.find('.customization-input').val()}</span>`;
                }
                 
                var mainpr = $popup.find(".acc-variant-item-inner.selected");
                var mainelem = $(this);
                var cleanPrice = Math.round(
                  mainelem.attr("data-selectedprice")
                );
                var producttitle = mainelem.attr("data-protitle");
                var titleelem = `<div class="acc-product-title">${mainelem.attr(
                  "data-protitle"
                )}</div>`;
                if (producttitle == "Default Title") {
                  titleelem = "";
                }
                var vartitlestr = `<div class="acc-variant-title">${mainpr.attr(
                    "data-vartitle"
                  )}</div>`;
                  if (mainpr.attr("data-vartitle") == "Default Title") {
                    vartitlestr = "";
                  }   
                  var personalizeHtmlAcc = ``; 
                  $popup.find('.personalize-wrap-acc.active').find('.personalize-input').each(function () {
                    var $wrap = $(this).closest('.personalize-wrap-acc');
                    var label = $wrap.find('.accessories-popup-label').text().trim();
                    var val   = $(this).val().trim();

                    if (val !== "") {
                      personalizeHtmlAcc += `<span><b>${label}:</b> <span class="tsoupdatefont">${val}</span></span>`;
                    }
                  });  


                if ($(this).attr("data-protype") == "custom") {
                  var canvasPri = $popup
                    .find(".accessories-popup-select.primary-colors")
                    .find("option:selected");      
                  var canvasSec = $popup
                    .find(".accessories-popup-select.secondary-colors")
                    .find("option:selected");
                  var imageData = 'https://tso.co/cdn/shop/files/' +  mainelem.attr("data-selectedsku") + '.jpg';
                  var fimageData = mainpr.attr("data-varimage");
                  $(".accessories-selected")
                    .append(`<div class="acc-product-card" data-card-type="accessory" data-acc-pid="${productId}">
                    <div class="acc-product-image">
                      <img src="${imageData}" class="retry-image" alt="Product">
                    </div>
                    <div class="acc-product-details">
                      ${titleelem}
                      <div class="acc-variant-title">${vartitlestr}</div>
                      <div class="acc-product-meta">
                        <span><b>SKU:</b> ${mainelem.attr("data-selectedsku")}</span>
                        <span><b>Primary Color:</b> ${canvasPri.attr("value")}</span>
                        <span><b>Secondary Color:</b> ${canvasSec.attr(
                          "value"
                        )}</span>
                        ${customizenotes}
                        ${personalizeHtmlAcc}
                      </div>
                      <div class="acc-product-price">
                        <span class="new-price">${cpbPriceHtml(cleanPrice, mainelem)}</span>
                      </div>
                      <div class="acc-product-actions">
                        <div class="quantity-selector">
                          <button type="button" class="qty-minus">−</button>
                          <input type="number" class="qty-input" value="1" min="1" max="99">
                          <button type="button" class="qty-plus">+</button>
                        </div>
                      </div>
                    </div>
                  </div>`);
                } else {
                  $(".accessories-selected")
                    .append(`<div class="acc-product-card" data-card-type="accessory" data-acc-pid="${productId}">
                    <div class="acc-product-image">
                      <img src="${mainpr.attr("data-varimage")}" alt="Product">
                    </div>
                    <div class="acc-product-details">
                      ${titleelem}
                      <div class="acc-variant-title">${vartitlestr}</div>
                      <div class="acc-product-meta">
                        ${personalizeHtmlAcc}
                      </div>
                      <div class="acc-product-price">
                        <span class="new-price">${cpbPriceHtml(cleanPrice, mainelem)}</span>
                      </div>
                      <div class="acc-product-actions">
                        <div class="quantity-selector">
                          <button type="button" class="qty-minus">−</button>
                          <input type="number" class="qty-input" value="1" min="1" max="99">
                          <button type="button" class="qty-plus">+</button>
                        </div>
                      </div>
                    </div>
                  </div>`);
                }
              }
            );
          } else {
            $(".summary-section.accessories-selected").hide();
          }
          // Custom color fee preview line. updateAllBoxPrices() (run here, after the summary cards
          // exist) folds the fee into the footer total and stamps data-colorfee; mirror it as an
          // itemized line so the summary total matches what's charged at checkout.
          this.updateAllBoxPrices();
          var ccfCents = Number($("custom-build-product").attr("data-colorfee") || 0);
          if (ccfCents > 0) {
            var ccfColors = this.getBuildFeeColors();
            var ccfLabel = ccfColors.length + ' custom color' + (ccfColors.length > 1 ? 's' : '') + ' · waived over $500';
            $(".products-selected").append(`<div class="acc-product-card" data-card-type="colorfee">
              <div class="acc-product-details">
                <div class="acc-product-title">Custom Color Fee</div>
                <div class="acc-variant-title">${ccfLabel}</div>
                <div class="acc-product-price"><span class="new-price">${Shopify.formatMoney(ccfCents)}</span></div>
              </div>
            </div>`);
          }

          const retryImage = new Event('retryImage');
          document.dispatchEvent(retryImage);
        }

        getBuildFeeColors() {
          // Distinct flagged color NAMES currently selected (main + selected accessories),
          // deduped order-wide by lowercased name — mirrors the cart reconcile + the _fee_colors
          // stamp. Used for the summary fee line + footer-total preview.
          var set = {};
          var collect = function () {
            var $o = $(this);
            if ($o.attr('data-feeunder500') === 'true') {
              var n = ($o.attr('data-value') || $o.val() || '').trim().toLowerCase();
              if (n) set[n] = 1;
            }
          };
          $('#primaryColorMain option:selected, #secondaryColorMain option:selected').each(collect);
          $('.accessories-product.selected').each(function () {
            var pid = $(this).attr('data-pid');
            $('.accessories-popup-overlay[data-pid="' + pid + '"]')
              .find('.accessories-popup-select.primary-colors option:selected, .accessories-popup-select.secondary-colors option:selected')
              .each(collect);
          });
          return Object.keys(set);
        }

        updateAllBoxPrices() {
           $('.error-msg').remove();
          var $selectedPrimary = $("#primaryColorMain").find("option:selected");
          var $selectedSecondary = $("#secondaryColorMain").find(
            "option:selected"
          );

          var selectedPrimaryChange = Number(
            $selectedPrimary.attr("data-primarychange") || 0
          );
          var selectedSecondaryChange = Number(
            $selectedSecondary.attr("data-secondarychange") || 0
          );
          var selectedPrimarySku = $selectedPrimary.attr("data-skucode") || "";
          var selectedSecondarySku =
            $selectedSecondary.attr("data-skucode") || "";
          var customSku =
            ($selectedPrimary.attr("data-basesku") || "") +
            selectedPrimarySku +
            selectedSecondarySku;
          $("custom-build-product").attr("data-selectedsku", customSku);
          var cprimaryChange = Number(
            $selectedPrimary.attr("data-primarychange") || 0
          );
          var csecondaryChange = Number(
            $selectedSecondary.attr("data-secondarychange") || 0
          );
          var cbasePrice = Number(
            $(".variant-item-inner.selected").attr("data-baseprice") || 0
          );
          var curPrice = cbasePrice;
          var primarychange = (cbasePrice * cprimaryChange) / 100;
          var secondarychange = (cbasePrice * csecondaryChange) / 100;
          // Finish tiers (docs/PRICING_TIERS_SPEC.md): a tier-mode product
          // prices the COMBO by its highest colour tier — the variant price
          // is tier 1, raw/2/3 ride on the variant. Null = not tier mode or
          // the variant is unpriced for tiers → the percent maths below.
          var tierPrice = cpbTierPrice(
            $("custom-build-product").attr("data-pricing-mode"),
            $(".variant-item-inner.selected")[0],
            $selectedPrimary[0],
            $selectedSecondary[0],
            $("custom-build-product").attr("data-coating-promo")
          );
          if (tierPrice !== null) {
            curPrice = tierPrice;
            primarychange = 0;
            secondarychange = 0;
            $(".primaryPriceChange, .secondaryPriceChange").html("");
            // Promo display: what this combo costs WITHOUT the promo, struck
            // through in the footer whenever the promo actually lowered it.
            var regular = cpbTierPrice(
              $("custom-build-product").attr("data-pricing-mode"),
              $(".variant-item-inner.selected")[0],
              $selectedPrimary[0],
              $selectedSecondary[0],
              0
            );
            var saved = regular !== null && regular > tierPrice;
            $("[data-cpb-promo-was]").prop("hidden", !saved).html(saved ? Shopify.formatMoney(regular) : "");
            $("[data-cpb-promo-badge]").prop("hidden", !saved);
          } else {
            curPrice += (cbasePrice * cprimaryChange) / 100;
            curPrice += (cbasePrice * csecondaryChange) / 100;
            curPrice -= 5;
            $(".primaryPriceChange").html(Shopify.formatMoney(primarychange));
            $(".secondaryPriceChange").html(Shopify.formatMoney(secondarychange));
          }
          $("custom-build-product").attr("data-totalprice", curPrice);

          // Footer total is qty-aware: main price * main qty + each accessory price * its qty.
          // Summary qty selectors default to 1 when absent (e.g. on build steps), so this is a
          // no-op there. Match accessories by data-pid -> summary card data-acc-pid (same as cart).
          var mainQty = parseInt($('.acc-product-card[data-card-type="main"] .qty-input').val()) || 1;
          var footerTotal = curPrice * mainQty;
          // footerSale = what the cart charges after the storefront promo,
          // per line like the automatic discount. footerTotal stays pre-promo:
          // the colour-fee waiver below keys off the cart's original_line_price
          // (snippets/custom-color-fee.liquid).
          var footerSale = cpbPromoPrice(footerTotal, $("custom-build-product"), mainQty);
          $(".accessories-product.selected").each(function () {
            var accQty = parseInt($('.acc-product-card[data-acc-pid="' + $(this).attr("data-pid") + '"] .qty-input').val()) || 1;
            var accLine = Number($(this).attr("data-selectedprice")) * accQty;
            footerTotal += accLine;
            footerSale += cpbPromoPrice(accLine, this, accQty);
          });

          // Custom color fee: $50 (5000c) per distinct flagged color, applied while merch < $500
          // (50000c). Stamp it on the host so the summary can itemize it, and fold it into the
          // displayed total so it matches what the cart reconcile charges at checkout.
          var ccfColorCount = this.getBuildFeeColors().length;
          var ccfCents = (ccfColorCount > 0 && footerTotal < 50000) ? ccfColorCount * 5000 : 0;
          $("custom-build-product").attr("data-colorfee", ccfCents);
          $('.acc-product-card[data-card-type="colorfee"]').toggle(ccfCents > 0);
          footerTotal += ccfCents;
          footerSale += ccfCents;
          var promoSaving = footerTotal - footerSale;
          $("[data-cpb-sale]").prop("hidden", promoSaving <= 0);
          $("[data-cpb-sale-amount]").html(promoSaving > 0 ? "−" + Shopify.formatMoney(promoSaving) : "");

          $(".selection-price-wrapper")
            .find(".total-price")
            .html(Shopify.formatMoney(footerSale));
          $(".selection-price-wrapper")
            .find(".affirm-as-low-as")
            .attr("data-amount", footerSale);
          this.refreshAffirmMessaging();
        }
        refreshAffirmMessaging() {
          var this2 = this;
          if (
            typeof affirm !== "undefined" &&
            affirm.ui &&
            typeof affirm.ui.refresh === "function"
          ) {
            affirm.ui.refresh();
          } else {
            // Retry after delay if Affirm isn't ready yet
            setTimeout(this2.refreshAffirmMessaging, 200);
          }
        }

        initCanvas() {
          var this2 = this;
          const canvas = document.getElementById("canvas");
          const parent = document.getElementById("main-canvas-wrapper");
          canvas.width = parent.offsetWidth;
          canvas.height = parent.offsetHeight;
          const ctx = canvas.getContext("2d");

          const imageSources = {
            baseImage: $("custom-build-product").attr("data-mainimage"),
            truckImage: $("custom-build-product").attr("data-truckimage"),
            tipImage: $("custom-build-product").attr("data-tipimage"),
            tipPolishedImage: $("custom-build-product").attr(
              "data-tippolishedimage"
            ),
            overlayImage: $("custom-build-product").attr("data-overlayimage"),
            overlayPolishedImage: $("custom-build-product").attr(
              "data-overlaypolishedimage"
            ),
            screwImage: $("custom-build-product").attr("data-screwimage"),
          };

          const images = {};
          let imagesLoaded = 0;
          const totalImages = Object.keys(imageSources).length;

          const checkAllImagesLoaded = () => {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
              drawAll();
            }
          };

          for (let key in imageSources) {
            images[key] = new Image();
            images[key].onload = checkAllImagesLoaded;
            images[key].onerror = (e) => {
              console.error(`Failed to load ${key}:`, e.target.src);
              checkAllImagesLoaded(); // prevent lockup on error
            };
            images[key].src = imageSources[key];
          }

          function setupHiDPICanvas(canvas, ctx) {
            const dpr = window.devicePixelRatio || 1;
            const rect = canvas.getBoundingClientRect();
            canvas.width = Math.round(rect.width * dpr);
            canvas.height = Math.round(rect.height * dpr);
            canvas.style.width = rect.width + "px";
            canvas.style.height = rect.height + "px";
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
          }

          function drawImageCover(ctx, img, dstW, dstH) {
            const sw = img.naturalWidth || img.width;
            const sh = img.naturalHeight || img.height;
            const sRatio = sw / sh;
            const dRatio = dstW / dstH;
            let sx = 0, sy = 0, sW = sw, sH = sh;
            if (sRatio > dRatio) {
              sW = Math.round(sh * dRatio);
              sx = Math.round((sw - sW) / 2);
            } else {
              sH = Math.round(sw / dRatio);
              sy = Math.round((sh - sH) / 2);
            }
            ctx.drawImage(img, sx, sy, sW, sH, 0, 0, dstW, dstH);
          }

          function tintAndDraw(ctx, img, colorHex, dstW, dstH) {
            const sw = img.naturalWidth || img.width;
            const sh = img.naturalHeight || img.height;
            const off = document.createElement("canvas");
            off.width = sw;
            off.height = sh;
            const octx = off.getContext("2d");
            octx.drawImage(img, 0, 0, sw, sh);
            octx.globalCompositeOperation = "multiply";
            octx.fillStyle = colorHex;
            octx.fillRect(0, 0, sw, sh);
            octx.globalCompositeOperation = "destination-in";
            octx.drawImage(img, 0, 0, sw, sh);
            ctx.drawImage(off, 0, 0, sw, sh, 0, 0, dstW, dstH);
          }

          function drawAll() {
            const primaryOption = $("#primaryColorMain").find("option:selected");
            const secondaryOption = $("#secondaryColorMain").find("option:selected");
            const primaryIsPolished = primaryOption.attr("data-value") === "Polished";
            const secondaryIsPolished = secondaryOption.attr("data-value") === "Polished";
            const primaryColor = primaryOption.attr("data-colorcode");
            const secondaryColor = secondaryOption.attr("data-colorcode");
            setupHiDPICanvas(canvas, ctx);
            const rect = canvas.getBoundingClientRect();
            const W = Math.round(rect.width);
            const H = Math.round(rect.height);
            ctx.clearRect(0, 0, W, H);
            drawImageCover(ctx, images.baseImage, W, H);
            drawImageCover(ctx, images.truckImage, W, H);
            if (primaryIsPolished) {
              drawImageCover(ctx, images.tipPolishedImage, W, H);
            } else {
              tintAndDraw(ctx, images.tipImage, primaryColor, W, H);
            }
            if (secondaryIsPolished) {
              drawImageCover(ctx, images.overlayPolishedImage, W, H);
            } else {
              tintAndDraw(ctx, images.overlayImage, secondaryColor, W, H);
            }
            drawImageCover(ctx, images.screwImage, W, H);
            this2.enableCanvasHoverZoom(canvas)
            // Pre-warm: upload the just-rendered preview in the background as colors
            // change, so the Shopify file exists by checkout and the buyer never waits.
            // Fire-and-forget — does NOT block the on-screen canvas render above.
            const primarysku = primaryOption.attr("data-skucode");
            const secondarysku = secondaryOption.attr("data-skucode");
            const cursku = $(".variant-item-inner.selected").attr("data-varsku");
            const customsku = cursku + primarysku + secondarysku + ".jpg";
            this2.uploadCanvasImage(canvas, customsku);
          }


          $("#primaryColorMain")
            .unbind()
            .change(function () {
              drawAll();
              this2.updateCustomBuildProductAttrs();
              this2.updateAllBoxPrices(); // inline "(+$X)" color chips
              updateCustomizationWrapMain();
            });
          $("#secondaryColorMain")
            .unbind()
            .change(function () {
              drawAll();
              this2.updateCustomBuildProductAttrs();
              this2.updateAllBoxPrices(); // inline "(+$X)" color chips
              updateCustomizationWrapMain();
            });
            function updateCustomizationWrapMain() { 
              var showCustom = false;
              $('#secondaryColorMain, #primaryColorMain').each(function() {
                  var $opt = $(this).find("option:selected"); 
                  if ($opt.data("colorcustom") === true || $opt.data("colorcustom") === "true") {
                      showCustom = true;
                  } 
              });
              if (showCustom) {
                  $('.color-options-step').find('.customization-wrap').show();
              } else {
                  $('.color-options-step').find('.customization-wrap').hide();
              }
          }
        }

        uploadCanvasImage(canvas, customsku) {
          return window.tsoUploadPreview(canvas, customsku);
        }

         syncAccessorySet($set) {
          if (!$set || !$set.length || $set.attr("data-single-select") !== "true") return;
          var $items = $set.find(".accessories-product");
          var hasSel = $set.find(".accessories-product.selected").length > 0;
          $items.each(function () {
            $(this).toggleClass("locked", hasSel && !$(this).hasClass("selected"));
          });
          var $h = $set.find(".accessory-set-header");
          if ($h.length) $h.text(hasSel ? $h.attr("data-selected") : $h.attr("data-choose"));
        }

        syncAllAccessorySets() {
          var self = this;
          $('.custom-product-variant-kit.accessories[data-single-select="true"]').each(function () {
            self.syncAccessorySet($(this));
          });
        }

         initAccesoriesPopup() {
          var this2 = this;
          $(".customize-button").on("click", function () {
            if ($(this).closest(".accessories-product").hasClass("locked")) return; // single-select: don't open locked siblings
            var overlay = document.querySelector('.accessories-popup-overlay[data-pid="' + $(this).attr("data-pid") + '"]');
            // portal to <body>: inside #MainContent the overlay is trapped in a lower
            // stacking context, so the sticky header painted OVER the modal and hid
            // the close button (unreachable on phones — audit fix)
            if (overlay && overlay.parentElement !== document.body) document.body.appendChild(overlay);
            $(overlay).addClass("active");
            const productId = $(this).data("pid");
            renderAccessoryCanvases(productId);
          });

          $(document).on("keydown.cpbPopupEsc", function (e) {
            if (e.key === "Escape" && $(".accessories-popup-overlay.active").length) {
              $(".accessories-popup-overlay").removeClass("active");
            }
          });

          $(".accessories-popup-overlay").on("click", function (e) {
            if (e.target === this) {
              $(".accessories-popup-overlay").removeClass("active");
            }
          });
          $(".accessories-popup-close").on("click", function (e) {
            $(".accessories-popup-overlay").removeClass("active");
          });

          $('.custom-variant-remove').unbind().click(function(){
            $(this).parents('.accessories-product').removeClass('selected');
            $(this).parents('.accessories-product').find('.selected_button').text('SELECT');
            this2.syncAccessorySet($(this).closest('.custom-product-variant-kit.accessories'));
            this2.updateAllBoxPrices();
            // accessory selection change — a required_products gate keyed on
            // this variant (elsewhere in the builder) must re-evaluate.
            this2.cpbEvaluateGates();
            this2.createAndSaveBundle();
          });

          /* Does this accessory actually ask the shopper anything? Only a real
             Shopify variant axis or a personalization field does; colors don't,
             because they always carry a valid default (first option selected).
             Ben 2026-08-17: "if there's no native variant to select or change,
             clicking Select should just select" — the popup was costing two
             clicks to confirm a choice that had already been made for you. */
          function accessoryNeedsChoice($popup) {
            if (!$popup || !$popup.length) return false;
            // a variant axis with more than one value to pick from
            var hasVariantAxis = false;
            // Count only REACHABLE values: cpbFilterAccessoryOptions hides +
            // disables the ones with no fitting variant, and a single survivor
            // is no choice — counting it kept the popup opening for a variant
            // the vehicle had already decided (caught live 2026-09-13).
            $popup.find(".accessories-popup-select.variant-options").each(function () {
              if (cpbReachableOptionCount(this.options) > 1) hasVariantAxis = true;
            });
            // Personalization ALWAYS needs the popup — the field starts empty and
            // the confirm handler refuses to proceed without it. Count only the
            // SHOWN rows: the snippet renders 10 .personalize-wrap-acc wrappers
            // unconditionally and reveals `number_of_text_boxes` of them via an
            // inline display style, so `.length` is 10 on every accessory and
            // would disable auto-select everywhere. Read the inline style rather
            // than :visible, because the popup is still display:none here.
            var hasPersonalization = false;
            $popup.find(".personalize-wrap-acc").each(function () {
              if ((this.style.display || "") !== "none") hasPersonalization = true;
            });
            // A colour the build picked that THIS part cannot carry (no
            // Polished in its palette, no such powder) also needs the popup:
            // auto-selecting here would ship the part in its default colour
            // without ever showing the shopper. The flag is maintained by the
            // inherit-first summary in custom-select-product-popup.liquid,
            // which syncs on initAccessoriesCanvas — i.e. right after the
            // seeding above, well before this click.
            var needsColor = $popup.attr("data-cpb-needs-color") === "1";
            return hasVariantAxis || hasPersonalization || needsColor;
          }

          $(".custom-product-variant-item.accessories-product")
            .find(".selected_button")
            .unbind()
            .click(function () {
              const $card = $(this).closest(".accessories-product");
              if ($card.hasClass("locked")) return; // single-select: don't open locked siblings
              const productId = $(this)
                .parents(".accessories-product")
                .find(".customize-button")
                .data("pid");
              var selOverlay = document.querySelector('.accessories-popup-overlay[data-pid="' + productId + '"]');
              // same portal as the customize path — this open path was missed in
              // the #101 fix, so SELECT-opened popups stayed stacking-trapped
              if (selOverlay && selOverlay.parentElement !== document.body) document.body.appendChild(selOverlay);
              var $selOverlay = $(selOverlay);

              // Nothing to ask AND not yet chosen -> select straight away. Clicking
              // an already-selected card still opens the popup, so colors remain
              // changeable on a second click. renderAccessoryCanvases runs FIRST:
              // it paints the CARD canvas that add-to-cart later reads for
              // _PreviewImage, and the card is on screen so it has real dimensions
              // (the popup's own canvas would measure 0 while hidden).
              if (!$card.hasClass("selected") && !accessoryNeedsChoice($selOverlay)) {
                renderAccessoryCanvases(productId);
                $selOverlay.find(".custom-cart-btn").trigger("click");
                return;
              }

              $selOverlay.addClass("active");

              renderAccessoryCanvases(productId);
            });

          $(".custom-cart-btn")
            .unbind()
            .click(function (e) {
              
              const productId = $(this)
                .parents(".accessories-popup-overlay")
                .attr("data-pid");
              const $popup = $(`.accessories-popup-overlay[data-pid='${productId}']`);

              var isValid = true;

              $popup.find('.personalize-wrap-acc:visible').each(function () {
                var $input = $(this).find('.personalize-input');
                if ($.trim($input.val()) === "") {
                  isValid = false;
                  $input.addClass('input-error'); // optional highlight
                } else {
                  $input.removeClass('input-error');
                }
              });                                       
  
              if (!isValid) {
                e.preventDefault(); // stop click
                e.stopPropagation(); // block next steps
                $popup.find('.error-msg').remove();
                var $pErr = $popup.find('.personalize-input.input-error').first();
                ($pErr.length ? $pErr.parent() : $popup.find('.personalize-input').last().parent())
                  .after(`<div class="error-msg" style="
                      color: #c12a22;
                      font-size: 14px;
                      font-weight: 600;
                      margin-top: 6px;
                  ">Please enter all required personalization fields.</div>`);
                if ($pErr.length) $pErr.trigger('focus');
                return false;
              }     


              const $main = $(`.custom-product-variant-item.accessories-product[data-pid='${productId}']`);
              $main.find(".selected_button").text("✓ SELECTED");
              $main.addClass("selected");
              this2.syncAccessorySet($main.closest(".custom-product-variant-kit.accessories"));
              $(".accessories-popup-overlay").removeClass("active");
              this2.updateAllBoxPrices();
              // accessory selection change — a required_products gate keyed on
              // this variant (elsewhere in the builder) must re-evaluate.
              this2.cpbEvaluateGates();



              var selectedvar = $popup.find(".acc-variant-item-inner.selected");
              var primarySku = $popup.find(".primary-colors").find("option:selected").data("skucode") || "";
              var secondarySku = $popup.find(".secondary-colors").find("option:selected").data("skucode") || "";
              var customSku =
                (selectedvar.attr("data-basesku") || "") +
                primarySku +
                secondarySku;
              var canvas = $popup.find("canvas")[0];
              this2.uploadCanvasImage(canvas, customSku + '.jpg');
              this2.createAndSaveBundle();
            });

          const accessoryState = {};

          function renderAccessoryCanvases(productId) {
            const $main = $(`.custom-product-variant-item.accessories-product[data-pid='${productId}']`);
            const $popup = $(`.accessories-popup-overlay[data-pid='${productId}']`);

            

            var selectedvar = $popup.find(".acc-variant-item-inner.selected");
            var basePrice = Number(selectedvar.attr("data-baseprice") || 0);
            var primaryChange = Number($popup.find(".primary-colors").find("option:selected").data("primarychange") || 0);
            var secondaryChange = Number($popup.find(".secondary-colors").find("option:selected").data("secondarychange") || 0);
            var primarySku = $popup.find(".primary-colors").find("option:selected").data("skucode") || "";
            var secondarySku = $popup.find(".secondary-colors").find("option:selected").data("skucode") || "";
            var customSku = (selectedvar.attr("data-basesku") || "") + primarySku + secondarySku;
             var accdiscount = Number($main.attr("data-accdiscount"));
            var curPrice = basePrice;
            curPrice += (basePrice * primaryChange) / 100;
            curPrice += (basePrice * secondaryChange) / 100;
            curPrice -= (curPrice * accdiscount) / 100;
            if($main.attr('data-protype') != 'regular'){
             curPrice -= 5;
            }
            $main.attr("data-selectedsku", customSku);
            $main.attr("data-selectedprice", curPrice);
            $popup.find(".accessories-popup-price").html(cpbPriceHtml(curPrice, $main));
            $main.find(".custom-variant-price").html(cpbPriceHtml(curPrice, $main));

            if($main.attr('data-protype') == 'regular'){
              return;
            }

            const canvases = [];
            $main.find("canvas").each(function () { canvases.push(this); });
            $popup.find("canvas").each(function () { canvases.push(this); });

            const $source = $main.length ? $main : $popup;
            const imageSources = {
              baseImage: $source.data("mainimage"),
              truckImage: $source.data("truckimage"),
              tipImage: $source.data("tipimage"),
              tipPolishedImage: $source.data("tippolishedimage"),
              overlayImage: $source.data("overlayimage"),
              overlayPolishedImage: $source.data("overlaypolishedimage"),
              screwImage: $source.data("screwimage"),
            };

            // Preload images
            const images = {};
            let imagesLoaded = 0;
            const totalImages = Object.keys(imageSources).length;
            function checkAllLoaded() {
              imagesLoaded++;
              if (imagesLoaded === totalImages) drawAllCanvases();
            }
            for (let key in imageSources) {
              images[key] = new window.Image();
              images[key].crossOrigin = "Anonymous";
              images[key].onload = checkAllLoaded;
              images[key].onerror = checkAllLoaded;
              images[key].src = imageSources[key];
            }

            function setupHiDPICanvas(canvas, ctx) {
              const dpr = window.devicePixelRatio || 1;
              const parent = $(canvas).parent()[0];
              const cssW = parent.offsetWidth;
              const cssH = parent.offsetHeight;
              canvas.width = Math.round(cssW * dpr);
              canvas.height = Math.round(cssH * dpr);
              canvas.style.width = cssW + "px";
              canvas.style.height = cssH + "px";
              ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = "high";
            }

            function drawImageStretch(ctx, img, dstW, dstH) {
              const sw = img.naturalWidth || img.width;
              const sh = img.naturalHeight || img.height;
              ctx.drawImage(img, 0, 0, sw, sh, 0, 0, dstW, dstH);
            }

            function tintImageAndDrawScaled(ctx, image, colorHex, scaleX, scaleY) {
              if (!colorHex) return;
              const sw = image.naturalWidth || image.width;
              const sh = image.naturalHeight || image.height;
              const off = document.createElement("canvas");
              off.width = sw;
              off.height = sh;
              const octx = off.getContext("2d");
              octx.drawImage(image, 0, 0, sw, sh);
              octx.globalCompositeOperation = "multiply";
              octx.fillStyle = colorHex;
              octx.fillRect(0, 0, sw, sh);
              octx.globalCompositeOperation = "destination-in";
              octx.drawImage(image, 0, 0, sw, sh);
              const dw = sw * scaleX;
              const dh = sh * scaleY;
              ctx.drawImage(off, 0, 0, sw, sh, 0, 0, dw, dh);
            }

            function hexToRgb(hex) {
              if (!hex) return [0, 0, 0];
              const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
              hex = hex.replace(shorthandRegex, (_, r, g, b) => r + r + g + g + b + b);
              const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
              return result
                ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
                : [0, 0, 0];
            }

            function drawAllCanvases() {
              for (const canvas of canvases) {
                const ctx = canvas.getContext("2d");
                setupHiDPICanvas(canvas, ctx);

                const parent = $(canvas).parent()[0];
                const cssW = parent.offsetWidth;
                const cssH = parent.offsetHeight;

                ctx.clearRect(0, 0, cssW, cssH);

                const state = accessoryState[productId];
                const primaryIsPolished = state.tipIsPolished;
                const secondaryIsPolished = state.overlayIsPolished;
                const primaryColor = state.tipColorCode;
                const secondaryColor = state.overlayColorCode;

                const baseW = images.baseImage.naturalWidth || images.baseImage.width;
                const baseH = images.baseImage.naturalHeight || images.baseImage.height;
                const scaleX = cssW / baseW;
                const scaleY = cssH / baseH;

                drawImageStretch(ctx, images.baseImage, cssW, cssH);
                drawImageStretch(ctx, images.truckImage, cssW, cssH);

                if (primaryIsPolished) {
                  drawImageStretch(ctx, images.tipPolishedImage, cssW, cssH);
                } else {
                  tintImageAndDrawScaled(ctx, images.tipImage, primaryColor, scaleX, scaleY);
                }

                if (secondaryIsPolished) {
                  drawImageStretch(ctx, images.overlayPolishedImage, cssW, cssH);
                } else {
                  tintImageAndDrawScaled(ctx, images.overlayImage, secondaryColor, scaleX, scaleY);
                }

                drawImageStretch(ctx, images.screwImage, cssW, cssH);
                this2.enableCanvasHoverZoom(canvas);
              }
            }

          }

          // Initialize state for each product (using <select>)
          $(".custom-product-variant-item.accessories-product").each(function () {
            const productId = $(this).data("pid");
            const $popup = $(`.accessories-popup-overlay[data-pid='${productId}']`);
            var primaryColor = $popup.find(".primary-colors").find("option:selected").data("colorcode");
            var secondaryColor = $popup.find(".secondary-colors").find("option:selected").data("colorcode");
            accessoryState[productId] = {
              tipIsPolished: false,
              overlayIsPolished: false,
              tipColorCode: primaryColor,
              overlayColorCode: secondaryColor,
            };
            const $main = $(`.custom-product-variant-item.accessories-product[data-pid='${productId}']`);
             
              renderAccessoryCanvases(productId);
            
          });

          // Handle changes in dropdowns (the new way!)
          $(document).on("change", ".accessories-popup-select", function () {
            const $select = $(this);
            const $popup = $select.closest(".accessories-popup-overlay");
            const productId = $popup.data("pid");
            const $main = $(`.custom-product-variant-item.accessories-product[data-pid='${productId}']`);
      
            // Primary color logic
            if ($select.hasClass("primary-colors")) {
                const $opt = $select.find("option:selected");
                accessoryState[productId].tipIsPolished = $opt.data("polished") === true || $opt.data("polished") === "true";
                accessoryState[productId].tipColorCode = $opt.data("colorcode");   
            } else if ($select.hasClass("secondary-colors")) {
                const $opt = $select.find("option:selected");  
                accessoryState[productId].overlayIsPolished = $opt.data("polished") === true || $opt.data("polished") === "true";
                accessoryState[productId].overlayColorCode = $opt.data("colorcode");
            }    

            updateCustomizationWrap($popup);


            // Variant logic
            if ($select.hasClass("variant-options")) {
              let selectedOptions = [];
              $popup.find(".accessories-popup-option-block.product-options").each(function () {
                let val = $(this).find("select").val();
                if (val !== undefined) selectedOptions.push(val);
              });

              let match = null;
              $popup.find(".acc-variant-item-inner").each(function () {
                let $el = $(this);
                let isMatch = true;
                for (let i = 1; i <= selectedOptions.length; i++) {
                  let optVal = $el.data("option" + i) || "";
                  if (optVal != selectedOptions[i - 1]) {
                    isMatch = false;
                    break;
                  }
                }    
                if (isMatch) {
                  match = $el;
                  return false;
                }
              });

              if (match) {
                $popup.find(".acc-variant-item-inner").removeClass("selected");
                match.addClass("selected");
                $main.attr("data-basesku", match.attr("data-basesku"));
                $main.attr("data-baseprice", match.attr("data-baseprice"));
                let attrs = [
                  "mainimage",
                  "truckimage",
                  "tipimage",
                  "tippolishedimage",
                  "overlayimage",
                  "overlaypolishedimage",
                  "screwimage",
                ];
                let $cbp = $main;
                attrs.forEach(function (attr) {
                  let value = match.data(attr);
                  if (typeof value !== "undefined") {
                    $cbp.attr("data-" + attr, value);
                  }
                });
                if (
                  $popup.find(".primary-colors").length > 0 &&
                  $popup.find(".secondary-colors").length > 0
                ) {
                  // Canvases update elsewhere
                } else {
                  $popup.find(".accessories-popup-img").find("img").attr("src", match.attr("data-varimage"));
                  $main.find(".custom-product-variant-image").find("img").attr("src", match.attr("data-varimage"));
                }
                
                var textboxcount = Number(match.attr('data-textboxcount'));
                $popup.find('.personalize-wrap').hide(); 
                $popup.find('.preview-text').hide(); 
                $popup.find('.personalize-wrap').removeClass('active'); 
                $popup.find('.personalize-wrap').find('.personalize-input').attr('maxlength',match.attr('data-textcharlimit'));
                $popup.find('.personalize-wrap').find('.personalize-count').html(match.attr('data-textcharlimit') + ' characters left');
                 var $previewWrapper = $popup.find(".preview-wrapper");
                var $previewText = $popup.find(".preview-text");
                $previewWrapper.hide();
                $previewText.text("");
                for (let index = 1; index <= textboxcount; index++) {
                  $popup.find('.personalize-wrap[data-row="'+index+'"]').show();
                  $popup.find('.preview-text[data-row="'+index+'"]').show(); 
                  if($popup.find('.personalize-wrap[data-row="'+index+'"]').find('input').val() != ''){
                    $previewWrapper.show();
                    $popup.find('.preview-text[data-row="'+index+'"]').html($popup.find('.personalize-wrap[data-row="'+index+'"]').find('input').val());
                  }
                  $popup.find('.personalize-wrap[data-row="'+index+'"]').addClass('active');
                }

                var pTextKey = textboxcount > 0 ? selectedOptions.join('') : '';
                if (pTextKey !== $popup.data('cpbTextKey')) {
                  $popup.data('cpbTextKey', pTextKey);
                  if (textboxcount > 0 && !window.__cpbRestoring && !window.__cpbTextApplying && window.TSOTextPicker) {
                    var pRoot = $popup[0];
                    var pBlock = $popup.find('.personalize-wrap-acc[data-row="1"]').parent()[0];
                    var pDbl = $popup.find('.accessories-popup-select.variant-options option').filter(function () { return this.value === 'Custom Text (Double Row)'; }).length > 0;
                    window.TSOTextPicker.open({ root: pRoot, block: pBlock, doubleCapable: pDbl, surface: 'popup', popup: pRoot });
                  } else if (window.TSOTextPicker) {
                    window.TSOTextPicker.closePanel();
                  }
                }
              }
            }

             
              renderAccessoryCanvases(productId);
            
          });

          function updateCustomizationWrap($popup) { 
              var showCustom = false;
              $popup.find('.primary-colors, .secondary-colors').each(function() {
                  var $opt = $(this).find("option:selected"); 
                  if ($opt.data("colorcustom") === true || $opt.data("colorcustom") === "true") {
                      showCustom = true;
                  } 
              }); 
              if (showCustom) {
                  $popup.find('.customization-wrap').show();
              } else {
                  $popup.find('.customization-wrap').hide();
              }
          }

          // Personalize input logic unchanged
          $(document).on("input", ".personalize-input", function () {
            var filtered = $(this).val().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\u2018\u2019]/g, "'").replace(/[^a-zA-Z0-9@#$&\-_.!?/%']/g, '');
            if (filtered !== $(this).val()) {
              $(this).val(filtered);
            }
            var $popup = $(this).closest(
              ".accessories-popup-overlay, .accessories-popup-content, .accessories-popup-body"
            );

            var $wrap = $(this).closest(".personalize-wrap");
            var $previewWrapper = $popup.find(".preview-wrapper");
            var index = $wrap.attr('data-row');
            var $previewText = $popup.find('.preview-text[data-row="'+index+'"]');
            var $count = $wrap.find(".personalize-count");
            var max = $(this).attr("maxlength") || 10;
            var val = $(this).val();

            if (val) {
              $previewWrapper.show();
              $previewText.text(val);
            } else {
              $previewWrapper.hide();
              $previewText.text("");
            }

            $count.text(max - val.length + " characters left");
          });
        }

        enableCanvasHoverZoom(canvas) {
          // const ctx = canvas.getContext("2d");

          // const zoom = 1;
          // const lensSize = 150;

          // // Capture RAW pixels (DPR-safe)
          // const baseImageData = ctx.getImageData(
          //   0,
          //   0,
          //   canvas.width,
          //   canvas.height
          // );

          // canvas.addEventListener("mousemove", (e) => {
          //   const rect = canvas.getBoundingClientRect();

          //   const mx = Math.round(
          //     (e.clientX - rect.left) * (canvas.width / rect.width)
          //   );
          //   const my = Math.round(
          //     (e.clientY - rect.top) * (canvas.height / rect.height)
          //   );

          //   const srcSize = Math.round(lensSize / zoom);

          //   // Clamp source
          //   const srcX = Math.max(
          //     0,
          //     Math.min(canvas.width - srcSize, mx - srcSize / 2)
          //   );
          //   const srcY = Math.max(
          //     0,
          //     Math.min(canvas.height - srcSize, my - srcSize / 2)
          //   );

          //   // Restore base pixels
          //   ctx.putImageData(baseImageData, 0, 0);

          //   // Extract zoom source
          //   const zoomData = ctx.getImageData(
          //     srcX,
          //     srcY,
          //     srcSize,
          //     srcSize
          //   );

          //   // Draw zoomed
          //   ctx.save();
          //   ctx.imageSmoothingEnabled = true;
          //   ctx.imageSmoothingQuality = "high";

          //   ctx.putImageData(
          //     zoomData,
          //     mx - srcSize / 2,
          //     my - srcSize / 2
          //   );

          //   ctx.drawImage(
          //     canvas,
          //     mx - srcSize / 2,
          //     my - srcSize / 2,
          //     srcSize,
          //     srcSize,
          //     mx - lensSize / 2,
          //     my - lensSize / 2,
          //     lensSize,
          //     lensSize
          //   );

          //   ctx.restore();

          //   // Border
          //   ctx.strokeStyle = "#ff8a00";
          //   ctx.lineWidth = 1;
          //   ctx.strokeRect(
          //     mx - lensSize / 2,
          //     my - lensSize / 2,
          //     lensSize,
          //     lensSize
          //   );
          // });

          // canvas.addEventListener("mouseleave", () => {
          //   ctx.putImageData(baseImageData, 0, 0);
          // });
        }



        async addAllProductsToCart(redirectTo = "/checkout") {
            const this2 = this;

            const mainelem = $("custom-build-product");
            const isCustomMain = mainelem.attr("data-protype") == "custom";
            const mainpr = $(".variant-item-inner.selected");
            const mainProductId = mainpr.attr("data-pid");
            const newVariantId = mainpr.attr("data-varid");
            // The master/parent part of this build. Captured HERE, in the outer
            // scope: the accessory loop below redeclares both `mainpr` and
            // `newVariantId` for its own popup, so neither is reachable from
            // inside it.
            const buildVariantUuid = canonicalUuid(mainpr.attr("data-dattumuuid"));
            const fittext = (function () {
              var sel = getVehicleSelection();
              if (!sel) return undefined; // no vehicle selected -> Fitment property omitted (JSON drops undefined)
              var label = sel.year + " " + sel.make + " " + sel.model;
              // reflect the selected main variant's ACTUAL fit, not just "a vehicle is selected"
              return (variantFitsVehicle(newVariantId, sel) ? "This Product Fits Your " : "This Product Does Not Fit Your ") + label;
            })();
            let newProperties = {};

            if (isCustomMain) {
              const primarysku = $("#primaryColorMain option:selected").attr("data-skucode") || "";
              const secondarysku = $("#secondaryColorMain option:selected").attr("data-skucode") || "";
              const customsku = mainelem.attr("data-selectedsku") + ".jpg";
              const canvas = $("#main-canvas-wrapper").find("canvas")[0];
              const previewImageUrl = await this.uploadCanvasImage(canvas, customsku);
              newProperties = {
                SKU: mainelem.attr("data-selectedsku") || "",
                "Primary Color": $("#primaryColorMain option:selected").attr("data-value") || "",
                "Secondary Color": $("#secondaryColorMain option:selected").attr("data-value") || "",
                _PreviewImage: previewImageUrl,
              };
              // Cart Transform v17 prices synced powders by metaobject GID only
              // (label lookup impossible function-side). Powder options carry
              // data-gid (powder-search.js); static colors don't and stay
              // label-only. A powder line WITHOUT its GID throws
              // UnmatchedColorError and blocks the whole cart.
              const priGid = $("#primaryColorMain option:selected").attr("data-gid");
              const secGid = $("#secondaryColorMain option:selected").attr("data-gid");
              if (priGid) newProperties["_Primary Color GID"] = priGid;
              if (secGid) newProperties["_Secondary Color GID"] = secGid;
              // Finish tier the combo landed in — display/audit only; the
              // Cart Transform re-derives it from the colours' own tiers.
              const lineTier = cpbTierOf(mainelem.attr("data-pricing-mode"), $("#primaryColorMain option:selected")[0], $("#secondaryColorMain option:selected")[0]);
              if (lineTier !== null) newProperties["_tier"] = String(lineTier);
              // ERP (Dattum) color ids — dattum_uuid off the color metaobject, so
              // the ERP reads an id instead of parsing the label. Key is omitted
              // until the ERP cron backfills the field (all entries empty as of
              // 2026-07-14); the ERP read-path falls back to the label parse.
              const priUuid = canonicalUuid($("#primaryColorMain option:selected").attr("data-dattumuuid"));
              const secUuid = canonicalUuid($("#secondaryColorMain option:selected").attr("data-dattumuuid"));
              if (priUuid) newProperties["_tso_color_primary_id"] = priUuid;
              if (secUuid) newProperties["_tso_color_secondary_id"] = secUuid;
              // WHICH TRUCK PAINT this colour was matched to. Purely ADDITIVE:
              // "Primary Color" and "_Primary Color GID" are untouched, so
              // pricing, the fee dedupe and the ERP's existing read path all
              // behave exactly as before and simply ignore these until they
              // learn them. Written whenever a match TILE made the pick.
              // Without it an unmapped side reaches the order as the generic
              // "Color Match" service — same label and same sentinel GID for
              // every paint on every truck, so a two-tone build is two
              // identical lines and the paint is unrecoverable.
              addMatchPaintProps(newProperties, $("#primaryColorMain option:selected"), $("#secondaryColorMain option:selected"));
            }

            newProperties["_ptype"] = "Product";
            newProperties["_uid"] = uid;
            // ERP (Dattum) part id for this exact variant. Every line carries its
            // own, always. Omitted until the ERP cron backfills
            // variant.metafields.custom.dattum_uuid.
            if (buildVariantUuid) newProperties["_tso_variant_id"] = buildVariantUuid;
            newProperties["Fitment"] = fittext;
            var installGuideUrl = resolveInstallGuideUrl();
            if (installGuideUrl) newProperties["_install_guide"] = installGuideUrl;

            // Custom-color fee: stamp the flagged color name(s) on this line, deduped
            // within the line (primary==secondary same color counts once). Reconcile
            // unions these across the cart. Empty/absent on non-custom products.
            var mainFeeColors = [];
            $('#primaryColorMain option:selected, #secondaryColorMain option:selected').each(function () {
              if ($(this).attr('data-feeunder500') === 'true') {
                var fcName = ($(this).attr('data-value') || $(this).val() || '').trim();
                if (fcName && mainFeeColors.indexOf(fcName) === -1) mainFeeColors.push(fcName);
              }
            });
            if (mainFeeColors.length) newProperties['_fee_colors'] = mainFeeColors.join('|');

             var showCustom = false;
            $('#secondaryColorMain, #primaryColorMain').each(function() {
                var $opt = $(this).find("option:selected"); 
                if ($opt.data("colorcustom") === true || $opt.data("colorcustom") === "true") {
                    showCustom = true;
                } 
            });
            var personalizeHtml = "";

            $('.personalize-wrap-main.active .personalize-input').each(function () {
              var $wrap = $(this).closest('.personalize-wrap-main');
              var label = $wrap.find('.personalize-label').text().trim();
              var val   = $(this).val().trim();

              if (val !== "") { 
                var keyper = "Personalization Text Row " + $(this).parents('.personalize-wrap-main').attr('data-row'); 
                newProperties[keyper] = val;
                personalizeHtml += `<span><b>${label}:</b> <span class="tsoupdatefont">${val}</span></span>`;
              }
            });

             
              if(mainpr.attr('data-text-row1') != ''){
                var keyini = "_Text Row 1";
                newProperties[keyini] = mainpr.attr('data-text-row1');
              }
              if(mainpr.attr('data-text-row2') != ''){
                var keyini = "_Text Row 2";
                newProperties[keyini] = mainpr.attr('data-text-row2');
              }
              var mainTextUuid = canonicalUuid($('custom-build-product').attr('data-tso-text-uuid'));
              if (mainTextUuid) newProperties['_tso_text_id'] = mainTextUuid;


            var customizenotes = ``;
            if($('.customization-input-main').val() != '' && showCustom == true){
              newProperties["Customization Notes"] = $('.customization-input-main').val();
            }
            

            var mainQty = parseInt($('.acc-product-card[data-card-type="main"] .qty-input').val()) || 1;

            let finalItems = [
              {
                id: newVariantId,
                quantity: mainQty,
                properties: newProperties
              }
            ];

            const accItems = $(".accessories-product.selected");

            for (let i = 0; i < accItems.length; i++) {
              const $acc = $(accItems[i]);
              const $popup = $(`.accessories-popup-overlay[data-pid='${$acc.data("pid")}']`);
              const isCustomAcc = $acc.attr("data-protype") == "custom";
              const mainpr = $popup.find(".acc-variant-item-inner.selected");
              const newVariantId = mainpr.attr("data-varid");
              const personalizeText = $popup.find(".personalize-input").val() || "";
              let accProperties = {};

              if (isCustomAcc) {
                const cursku = $acc.attr("data-selectedsku") || "";
                const customsku = cursku + ".jpg";
                const canvas = $acc.find("canvas")[0];
                const previewImageUrl = await this.uploadCanvasImage(canvas, customsku);
                accProperties = {
                  SKU: cursku,
                  "Primary Color": $popup.find(".accessories-popup-select.primary-colors option:selected").attr("data-value") || "",
                  "Secondary Color": $popup.find(".accessories-popup-select.secondary-colors option:selected").attr("data-value") || "",
                  _PreviewImage: previewImageUrl,
                  Fitment: fittext,
                };
                // powder GID contract — same as the main build (Cart Transform
                // v17 needs the metaobject GID; static colors stay label-only)
                const accPriGid = $popup.find(".accessories-popup-select.primary-colors option:selected").attr("data-gid");
                const accSecGid = $popup.find(".accessories-popup-select.secondary-colors option:selected").attr("data-gid");
                if (accPriGid) accProperties["_Primary Color GID"] = accPriGid;
                if (accSecGid) accProperties["_Secondary Color GID"] = accSecGid;
                // ERP (Dattum) color ids — same contract as the main build line
                const accPriUuid = canonicalUuid($popup.find(".accessories-popup-select.primary-colors option:selected").attr("data-dattumuuid"));
                const accSecUuid = canonicalUuid($popup.find(".accessories-popup-select.secondary-colors option:selected").attr("data-dattumuuid"));
                if (accPriUuid) accProperties["_tso_color_primary_id"] = accPriUuid;
                if (accSecUuid) accProperties["_tso_color_secondary_id"] = accSecUuid;
                addMatchPaintProps(accProperties,
                  $popup.find(".accessories-popup-select.primary-colors option:selected"),
                  $popup.find(".accessories-popup-select.secondary-colors option:selected"));
                 var showCustom = false;
                $popup.find('.primary-colors, .secondary-colors').each(function() {
                    var $opt = $(this).find("option:selected"); 
                    if ($opt.data("colorcustom") === true || $opt.data("colorcustom") === "true") {
                        showCustom = true;
                    } 
                }); 

                
                if($popup.find('.customization-input').val() != '' && showCustom == true){
                  accProperties['Customization Notes'] = $popup.find('.customization-input').val();  
                }
                 
              } else {

                
                 
                accProperties["Fitment"] = fittext;
              }

              $popup.find('.personalize-wrap-acc.active').find('.personalize-input').each(function () {
                var $wrap = $(this).closest('.personalize-wrap-acc');
                var label = $wrap.find('.personalize-label').text().trim();
                var val   = $(this).val().trim();

                if (val !== "") { 
                  var keyper = "Personalization Text Row " + $(this).parents('.personalize-wrap-acc').attr('data-row'); 
                  accProperties[keyper] = val;
                  personalizeHtml += `<span><b>${label}:</b> <span class="tsoupdatefont">${val}</span></span>`;
                }
              });

              if(mainpr.attr('data-text-row1') != ''){
                var keyini = "_Text Row 1";
                accProperties[keyini] = mainpr.attr('data-text-row1');
              }
              if(mainpr.attr('data-text-row2') != ''){
                var keyini = "_Text Row 2";
                accProperties[keyini] = mainpr.attr('data-text-row2');
              }
              var accTextUuid = canonicalUuid($popup.attr('data-tso-text-uuid'));
              if (accTextUuid) accProperties['_tso_text_id'] = accTextUuid;

              accProperties["_ptype"] = "Accessory";
              accProperties["_uid"] = uid;
              // This accessory's own part id, same as every other line.
              const accVariantUuid = canonicalUuid(mainpr.attr("data-dattumuuid"));
              if (accVariantUuid) accProperties["_tso_variant_id"] = accVariantUuid;
              // ...plus the master part it was built against. _uid groups the
              // bundle but is a throwaway client id naming no part, so without
              // this a "Ford frame overlay personalization" line can only say
              // "I'm in this build", not which overlay it personalizes.
              // Every accessory line, custom or not.
              if (buildVariantUuid) accProperties["_tso_build_variant_id"] = buildVariantUuid;

              // Custom-color fee: stamp flagged accessory color name(s), deduped within line.
              var accFeeColors = [];
              $popup.find('.accessories-popup-select.primary-colors option:selected, .accessories-popup-select.secondary-colors option:selected').each(function () {
                if ($(this).attr('data-feeunder500') === 'true') {
                  var afcName = ($(this).attr('data-value') || $(this).val() || '').trim();
                  if (afcName && accFeeColors.indexOf(afcName) === -1) accFeeColors.push(afcName);
                }
              });
              if (accFeeColors.length) accProperties['_fee_colors'] = accFeeColors.join('|');

              var accQty = parseInt($(`.acc-product-card[data-acc-pid="${$acc.data("pid")}"] .qty-input`).val()) || 1;

              finalItems.push({
                id: newVariantId,
                quantity: accQty,
                properties: accProperties,
              });
            }

            // ---- dynamic lead time (tso-lead-time.js): base range + MAX of option
            // delays, elementwise max across the build. _lead_days_max = hidden
            // numeric for the cart page's "up to X" line.
            if (window.TSOLead) {
              var buildLead = window.TSOLead.compute();
              if (buildLead && buildLead.max > 0) {
                finalItems[0].properties["Lead Time"] = window.TSOLead.format(buildLead.min, buildLead.max);
                finalItems[0].properties["_lead_days_max"] = String(buildLead.max);
              }
            }

            // Vehicle paint attribution (2026-07-04): the YMM paint + trim land
            // on the ORDER as note_attributes (cart attributes) so ops/ERP see
            // them without opening line properties. Set in the success chain so
            // the cart mutations stay sequential.
            var paintAttrs = null;
            (function () {
              var vsel = getVehicleSelection();
              if (!vsel) return;
              var a = {};
              if (vsel.paint_color) a["Vehicle Paint Color"] = vsel.paint_color;
              if (vsel.two_tone_paint_color) a["Vehicle Trim Paint Color"] = vsel.two_tone_paint_color;
              if (a["Vehicle Paint Color"] || a["Vehicle Trim Paint Color"]) paintAttrs = a;
            })();

            //await $.post("/cart/clear.js");

            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: JSON.stringify({ items: finalItems }),
              dataType: "json",
              contentType: "application/json",
              success: function (res) {
                // Reconcile the custom-color fee before leaving — the Complete-Checkout
                // path goes straight to /checkout and skips the cart-page watcher.
                var attrPost = paintAttrs
                  ? $.ajax({ type: "POST", url: "/cart/update.js", data: JSON.stringify({ attributes: paintAttrs }), dataType: "json", contentType: "application/json" })
                  : null;
                Promise.resolve(attrPost)
                  .then(function () { return window.reconcileCustomColorFee && window.reconcileCustomColorFee(); })
                  .finally(function () { window.location.href = redirectTo; });
              },
              error: function (err) {
                $('.error-msg').remove();
                var rj = err.responseJSON || {};
                var atcMsg = rj.description || rj.message || (err.status === 429 ? "Too many requests — wait a moment and try again." : "Could not add to cart (" + (err.status || "network") + "). Please try again.");
                console.error("[builder ATC] add failed", err.status, err.responseText && err.responseText.slice(0, 300));
                if (window.tsoReportError) window.tsoReportError("builder: /cart/add.js failed (" + (err.status || "network") + ")", {
                  status: err.status,
                  response: err.responseText && err.responseText.slice(0, 500),
                  items: finalItems.map(function (it) { return { id: it.id, quantity: it.quantity }; })
                });
                $('.custom-build-product-footer .btn-wrapper').before('<div class="error-msg" style="color:#c12a22;font-size:14px;font-weight:600;text-align:center;margin:6px 0;">' + atcMsg + '</div>');
                $('.nextbutton').html(`<div class="" bis_skin_checked="1">
                  <div class="next-text" bis_skin_checked="1">CHECKOUT</div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M7.38 21.01c.49.49 1.28.49 1.77 0l8.31-8.31a.996.996 0 0 0 0-1.41L9.15 2.98c-.49-.49-1.28-.49-1.77 0s-.49 1.28 0 1.77L14.62 12l-7.25 7.25c-.48.48-.48 1.28.01 1.76"></path>
                  </svg>
                </div>`);
                $('.continue-link-checkout').html('Add to Cart');
                // click handlers disable both CTAs before the call — re-enable
                // or the buyer is stuck on a dead button until reload
                $('.nextbutton, .continue-link-checkout').prop('disabled', false);
                console.error(err);
              }
            });
          }


        createAndSaveBundle(){
          var iscustom = false;
          if(currentProductType == 'custom'){
            iscustom = true;
          }
           
          var mainpr = {
            id: currentProductId,
            title: currentProductTitle,
            is_custom: iscustom,
            options:{
              option1:$('.option-index1').find('.value-item:checked').attr('value'),
              option2:$('.option-index2').find('.value-item:checked').attr('value'),
              option3:$('.option-index3').find('.value-item:checked').attr('value')
            },
            personalizations:{
              line1:$('.personalize-wrap-main[data-row="1"]').find('.personalize-input').val(), 
              line2:$('.personalize-wrap-main[data-row="2"]').find('.personalize-input').val(), 
              line3:$('.personalize-wrap-main[data-row="3"]').find('.personalize-input').val(), 
              line4:$('.personalize-wrap-main[data-row="4"]').find('.personalize-input').val(), 
              line5:$('.personalize-wrap-main[data-row="5"]').find('.personalize-input').val(), 
              line6:$('.personalize-wrap-main[data-row="6"]').find('.personalize-input').val(), 
              line7:$('.personalize-wrap-main[data-row="7"]').find('.personalize-input').val(), 
              line8:$('.personalize-wrap-main[data-row="8"]').find('.personalize-input').val(), 
              line9:$('.personalize-wrap-main[data-row="9"]').find('.personalize-input').val(), 
              line10:$('.personalize-wrap-main[data-row="10"]').find('.personalize-input').val(),
            },
            textPick:{
              uuid: $('custom-build-product').attr('data-tso-text-uuid') || '',
              rows: $('.personalize-wrap-main.active .personalize-input[readonly]').length
            }
          }
          if(iscustom == true){
              mainpr['colors'] = {
                primary : $('#primaryColorMain').find('option:selected').attr('data-value'),
                secondary : $('#secondaryColorMain').find('option:selected').attr('data-value'),
              }
              mainpr['customizenotes'] = $('.customization-input-main').val();
          }

          var accessories = [];
          $('.accessories-product.selected').each(function(){
              var isacccustom = false;
              
              var $popup = $('.accessories-popup-overlay[data-pid="'+$(this).attr('data-pid')+'"]')
              if($(this).attr('data-protype') == 'custom'){
                isacccustom = true;
              }
              var accepr = {
                id: $(this).attr('data-pid'),
                title: $(this).attr('data-protitle'),
                is_custom: isacccustom,
                options:{
                  option1: $popup.find('.option-1').find('.accessories-popup-select').find('option:selected').attr('value'),
                  option2: $popup.find('.option-2').find('.accessories-popup-select').find('option:selected').attr('value'),
                  option3: $popup.find('.option-3').find('.accessories-popup-select').find('option:selected').attr('value'),
                },
                personalizations:{
                  line1:$popup.find('.personalize-wrap[data-row="1"]').find('.personalize-input').val(), 
                  line2:$popup.find('.personalize-wrap[data-row="2"]').find('.personalize-input').val(), 
                  line3:$popup.find('.personalize-wrap[data-row="3"]').find('.personalize-input').val(), 
                  line4:$popup.find('.personalize-wrap[data-row="4"]').find('.personalize-input').val(), 
                  line5:$popup.find('.personalize-wrap[data-row="5"]').find('.personalize-input').val(), 
                  line6:$popup.find('.personalize-wrap[data-row="6"]').find('.personalize-input').val(), 
                  line7:$popup.find('.personalize-wrap[data-row="7"]').find('.personalize-input').val(), 
                  line8:$popup.find('.personalize-wrap[data-row="8"]').find('.personalize-input').val(), 
                  line9:$popup.find('.personalize-wrap[data-row="9"]').find('.personalize-input').val(), 
                  line10:$popup.find('.personalize-wrap[data-row="10"]').find('.personalize-input').val(),
                },
                textPick:{
                  uuid: $popup.attr('data-tso-text-uuid') || '',
                  rows: $popup.find('.personalize-wrap-acc.active .personalize-input[readonly]').length
                }
              }

              if(isacccustom == true){
                  accepr['colors'] = {
                    primary : $popup.find('.primary-colors').find('option:selected').attr('value'),
                    secondary : $popup.find('.secondary-colors').find('option:selected').attr('value'),
                  }
                  accepr['customizenotes'] = $popup.find('.customization-input').val();
              }
               
              accessories.push(accepr);  
          })
          var curPanel = document.querySelector('.custom-product-content-step.current');
          var savejson = {
            main_product: mainpr,
            // Canonical DOM position (stable under hiding), NOT the static
            // product-step attribute. Byte-identical to the pre-Task-5 shape:
            // string, 1-based, over ALL panels in document order (hidden ones
            // still count); key OMITTED (not 0) when no panel is .current.
            // This crosses to a third-party bundle server (BundleManager ->
            // customer metafield) whose schema/typeof checks we cannot
            // inspect, so the type + no-current shape are preserved exactly.
            // Restore ignores this field today (:2415-2417, the B2 fix).
            current_step: curPanel
              ? String(Array.prototype.indexOf.call(
                  document.querySelectorAll('.custom-product-content-step'), curPanel) + 1)
              : undefined,
          }
          if(accessories.length > 0){
            savejson['accessories'] = accessories;
          }
          window.BundleManager.saveOrUpdateBundleByProduct(savejson);
        }

        setSavedData() {
          var this2 = this;  
  
          window.BundleManager.restoreBundleForCurrentProduct(function(bundle) {

           try {

            // Task 5: suppress the approved-text picker's auto-reveal while
            // bundle values are being programmatically re-applied below --
            // Task 3's reveal hook checks this flag. Cleared in `finally`
            // (below) so it resets on every path, including a thrown error.
            window.__cpbRestoring = true;

            if (bundle && bundle.main_product && bundle.main_product.options) {
              if (bundle.main_product.options.option1 != null) {
                $('.option-index1')
                  .find('.value-item[value="' + bundle.main_product.options.option1 + '"]')
                  .prop('checked', true);
              }

              if (bundle.main_product.options.option2 != null) {
                $('.option-index2')
                  .find('.value-item[value="' + bundle.main_product.options.option2 + '"]')
                  .prop('checked', true);
              }

              if (bundle.main_product.options.option3 != null) {
                $('.option-index3')
                  .find('.value-item[value="' + bundle.main_product.options.option3 + '"]')
                  .prop('checked', true);
              }
              if(bundle.main_product.personalizations != null){
                $('.personalize-wrap-main[data-row="1"]').find('.personalize-input').val(bundle.main_product.personalizations.line1);
                $('.personalize-wrap-main[data-row="2"]').find('.personalize-input').val(bundle.main_product.personalizations.line2);
                $('.personalize-wrap-main[data-row="3"]').find('.personalize-input').val(bundle.main_product.personalizations.line3);
                $('.personalize-wrap-main[data-row="4"]').find('.personalize-input').val(bundle.main_product.personalizations.line4);
                $('.personalize-wrap-main[data-row="5"]').find('.personalize-input').val(bundle.main_product.personalizations.line5);
                $('.personalize-wrap-main[data-row="6"]').find('.personalize-input').val(bundle.main_product.personalizations.line6);
                $('.personalize-wrap-main[data-row="7"]').find('.personalize-input').val(bundle.main_product.personalizations.line7);
                $('.personalize-wrap-main[data-row="8"]').find('.personalize-input').val(bundle.main_product.personalizations.line8);
                $('.personalize-wrap-main[data-row="9"]').find('.personalize-input').val(bundle.main_product.personalizations.line9);
                $('.personalize-wrap-main[data-row="10"]').find('.personalize-input').val(bundle.main_product.personalizations.line10);
              }

              if (bundle.main_product.textPick && bundle.main_product.textPick.uuid) {
                $('custom-build-product').attr('data-tso-text-uuid', bundle.main_product.textPick.uuid);
                var lockRows = Number(bundle.main_product.textPick.rows) || 0;
                $('.personalize-wrap-main').each(function () {
                  var r = Number($(this).attr('data-row'));
                  $(this).find('.personalize-input').prop('readonly', r <= lockRows);
                });
              }

              if (bundle.main_product.is_custom === true && bundle.main_product.colors) {
                // catalog powders are injected <option>s — they don't exist on a
                // fresh load, so restore them through the catalog (same pattern
                // as the accessory seeding). injectByLabel -> pick() also stamps
                // data-gid, which the Cart Transform GID contract needs.
                const restoreColor = function ($sel, label) {
                  if (!$sel.length || label == null) return;
                  const exists = $sel.find('option').filter(function () { return this.value === label; }).length;
                  if (exists) { cpbSetSelect($sel, label); }
                  else if (window.TSOPowder) { window.TSOPowder.injectByLabel($sel[0], label); }
                };
                restoreColor($('#primaryColorMain'), bundle.main_product.colors.primary);
                restoreColor($('#secondaryColorMain'), bundle.main_product.colors.secondary);
                if (bundle.main_product.customizenotes != null) {
                  $('.customization-input-main').val(bundle.main_product.customizenotes);
                }
              }
               

              if (Array.isArray(bundle.accessories) && bundle.accessories.length > 0) {
                for (let index = 0; index < bundle.accessories.length; index++) {
                  const element = bundle.accessories[index];
                  if (!element || !element.id || !element.options) continue;

                  var $acc = $('.accessories-product[data-pid="' + element.id + '"]');
                  var $popup = $('.accessories-popup-overlay[data-pid="' + element.id + '"]');

                  if (element.options.option1 != null) {
                     cpbSetSelect($popup.find('.option-1').find('.accessories-popup-select'), element.options.option1); 
                  }

                  if (element.options.option2 != null) {
                    cpbSetSelect($popup.find('.option-2').find('.accessories-popup-select'), element.options.option2); 
                  }

                  if (element.options.option3 != null) {
                    cpbSetSelect($popup.find('.option-3').find('.accessories-popup-select'), element.options.option3); 
                  }
                  if(element.personalizations != null){
                    $popup.find('.personalize-wrap[data-row="1"]').find('.personalize-input').val(element.personalizations.line1);
                    $popup.find('.personalize-wrap[data-row="2"]').find('.personalize-input').val(element.personalizations.line2);
                    $popup.find('.personalize-wrap[data-row="3"]').find('.personalize-input').val(element.personalizations.line3);
                    $popup.find('.personalize-wrap[data-row="4"]').find('.personalize-input').val(element.personalizations.line4);
                    $popup.find('.personalize-wrap[data-row="5"]').find('.personalize-input').val(element.personalizations.line5);
                    $popup.find('.personalize-wrap[data-row="6"]').find('.personalize-input').val(element.personalizations.line6);
                    $popup.find('.personalize-wrap[data-row="7"]').find('.personalize-input').val(element.personalizations.line7);
                    $popup.find('.personalize-wrap[data-row="8"]').find('.personalize-input').val(element.personalizations.line8);
                    $popup.find('.personalize-wrap[data-row="9"]').find('.personalize-input').val(element.personalizations.line9);
                    $popup.find('.personalize-wrap[data-row="10"]').find('.personalize-input').val(element.personalizations.line10);
                  }

                  if (element.textPick && element.textPick.uuid) {
                    $popup.attr('data-tso-text-uuid', element.textPick.uuid);
                    var accLockRows = Number(element.textPick.rows) || 0;
                    $popup.find('.personalize-wrap-acc').each(function () {
                      var r = Number($(this).attr('data-row'));
                      $(this).find('.personalize-input').prop('readonly', r <= accLockRows);
                    });
                  }

                  if (element.is_custom === true && element.colors) {
                    if (element.colors.primary != null) {
                      cpbSetSelect($popup.find('.primary-colors'), element.colors.primary);  
                    }

                    if (element.colors.secondary != null) {
                      cpbSetSelect($popup.find('.secondary-colors'), element.colors.secondary); 
                    }

                    if (element.customizenotes != null) {
                      $popup.find('.customization-input').val(element.customizenotes);
                    }

                  }
                  if(element.textinput){
                    $popup.find('.personalize-input').val(element.textinput);
                  }
                  $acc.find(".selected_button").text("✓ SELECTED");
                  $acc.addClass('selected');
                   
                }
              }

              this2.syncAllAccessorySets();

              // B2: selections are restored above, but do NOT jump to the saved
              // step — returning shoppers were landing straight on Summary
              // (looked broken; wrong-config ATC risk). Always start at step 1.

              this2.updateCustomBuildProductAttrs();  
               
              this2.updateAllBoxPrices();
              
              this2.initAccesoriesPopup();
              // (no auto-scroll on restore — yanking the page to the builder on
              // load was part of the same B2 complaint)
              document.dispatchEvent(new Event("initSummary"));
             

            } else {
              // If no bundle found, handle as needed (e.g. reset UI or show message)
            }

           } finally {
            // Task 5: resume the picker's normal reveal behavior. `finally`
            // runs on every path out of the try above -- bundle-found,
            // no-bundle (else branch), or a thrown error -- so this can't
            // be left permanently true by an early exit.
            window.__cpbRestoring = false;

            // D9 (Task 6) hardening: the block above is ~140 lines of
            // fragile restore work (window.TSOPowder.injectByLabel,
            // updateCustomBuildProductAttrs(), syncAllAccessorySets(),
            // initAccesoriesPopup()) sitting between two upstream systems
            // we don't control -- most notably custom-build-product-save.js
            // doing String(b.main_product.id) inside a bare .find() over
            // the customer's saved-bundle array, which throws if any
            // legacy entry is missing main_product (most likely on the
            // bundle-FOUND branch, exactly where gates matter most). A
            // throw anywhere in the try body must not leave cpbGatesReady
            // unset forever -- that would make every cpbEvaluateGates()
            // call site a permanent no-op for the rest of the page's life.
            // finally does NOT swallow the error: it still propagates after
            // this block runs, so failures stay visible/loggable exactly as
            // before this change.
            //
            // Settle point for D9 (Task 6): restoreBundleForCurrentProduct
            // calls THIS callback exactly once, whichever branch above ran
            // -- guest sync lookup, logged-in metafield hit, logged-in
            // localStorage fallback (still inside .done()), or the
            // .fail() network-error fallback. All of them funnel here, so
            // flipping the flag + evaluating in this one place covers both
            // the sync and async restore paths without duplicating the
            // call at each branch. Do this BEFORE any other code gets a
            // chance to call cpbEvaluateGates() against a settled DOM --
            // see the guard at the top of cpbEvaluateGates() for why
            // evaluating any earlier is unsafe.
            //
            // skipPersist: true -- this evaluation is a pure side effect of
            // page load, not a user action; see the matching comment at the
            // pricesDirty persist inside cpbEvaluateGates().
            this2.cpbGatesReady = true;
            this2.cpbEvaluateGates({ skipPersist: true });

            // Task 7: prereq resolution runs HERE, not at the end of
            // initSteps() -- setSavedData()'s restore is async
            // (restoreBundleForCurrentProduct's callback), so this settle
            // point is the only spot guaranteed to be AFTER the saved
            // selection is restored into the DOM. Reconciles + hides/shows
            // prereq/target pairs against the restored state.
            this2.cpbRunPrereqResolution();
           }

          });
         
                document.getElementById("fullPageLoader").style.display = "none";
              
        } 



        connectedCallback() {
          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
          };
          new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: "0px 0px 400px 0px",
          }).observe(this);
        }
      }
    );
  }
});

// master-parity: restore the page scroll position after the builder's
// reset-confirm reload (saved right before window.location.reload above)
window.addEventListener('DOMContentLoaded', function () {
  const position = localStorage.getItem('scrollToPosition');
  if (position !== null) {
    window.scrollTo({ top: Number(position), behavior: 'smooth' });
    localStorage.removeItem('scrollToPosition');
  }
});

